(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Cryptolize"] = factory();
	else
		root["Cryptolize"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyDerivation = __webpack_require__(23);
	
	Object.defineProperty(exports, 'deriveKey', {
	  enumerable: true,
	  get: function () {
	    return _keyDerivation.deriveKey;
	  }
	});
	
	var _random = __webpack_require__(15);
	
	Object.defineProperty(exports, 'createRandom', {
	  enumerable: true,
	  get: function () {
	    return _random.createRandom;
	  }
	});
	Object.defineProperty(exports, 'createKey', {
	  enumerable: true,
	  get: function () {
	    return _random.createKey;
	  }
	});
	Object.defineProperty(exports, 'createIV', {
	  enumerable: true,
	  get: function () {
	    return _random.createIV;
	  }
	});
	
	var _ecc = __webpack_require__(10);
	
	Object.defineProperty(exports, 'createAsymmetricKeys', {
	  enumerable: true,
	  get: function () {
	    return _ecc.createAsymmetricKeys;
	  }
	});
	Object.defineProperty(exports, 'createAsymmetricKeysECDSA', {
	  enumerable: true,
	  get: function () {
	    return _ecc.createAsymmetricKeysECDSA;
	  }
	});
	Object.defineProperty(exports, 'signWithECDSAPrivateKey', {
	  enumerable: true,
	  get: function () {
	    return _ecc.signWithECDSAPrivateKey;
	  }
	});
	Object.defineProperty(exports, 'verifyWithECDSAPublicKey', {
	  enumerable: true,
	  get: function () {
	    return _ecc.verifyWithECDSAPublicKey;
	  }
	});
	
	var _format = __webpack_require__(4);
	
	Object.defineProperty(exports, 'createRecordMetadata', {
	  enumerable: true,
	  get: function () {
	    return _format.createRecordMetadata;
	  }
	});
	Object.defineProperty(exports, 'createEncryptionParams', {
	  enumerable: true,
	  get: function () {
	    return _format.createEncryptionParams;
	  }
	});
	
	var _aes = __webpack_require__(7);
	
	Object.defineProperty(exports, 'encryptText', {
	  enumerable: true,
	  get: function () {
	    return _aes.encryptText;
	  }
	});
	Object.defineProperty(exports, 'decryptText', {
	  enumerable: true,
	  get: function () {
	    return _aes.decryptText;
	  }
	});
	Object.defineProperty(exports, 'encryptObject', {
	  enumerable: true,
	  get: function () {
	    return _aes.encryptObject;
	  }
	});
	Object.defineProperty(exports, 'decryptObject', {
	  enumerable: true,
	  get: function () {
	    return _aes.decryptObject;
	  }
	});
	Object.defineProperty(exports, 'encryptKey', {
	  enumerable: true,
	  get: function () {
	    return _aes.encryptKey;
	  }
	});
	Object.defineProperty(exports, 'decryptKey', {
	  enumerable: true,
	  get: function () {
	    return _aes.decryptKey;
	  }
	});
	
	var _record = __webpack_require__(35);
	
	Object.defineProperty(exports, 'encryptRecord', {
	  enumerable: true,
	  get: function () {
	    return _record.encrypt;
	  }
	});
	Object.defineProperty(exports, 'decryptRecord', {
	  enumerable: true,
	  get: function () {
	    return _record.decrypt;
	  }
	});
	
	var _header = __webpack_require__(26);
	
	Object.defineProperty(exports, 'decryptKeyWithSymmetricEncryption', {
	  enumerable: true,
	  get: function () {
	    return _header.decryptKeyWithSymmetricEncryption;
	  }
	});
	Object.defineProperty(exports, 'decryptKeyWithAsymmetricEncryption', {
	  enumerable: true,
	  get: function () {
	    return _header.decryptKeyWithAsymmetricEncryption;
	  }
	});
	Object.defineProperty(exports, 'hasSymmetricEncryption', {
	  enumerable: true,
	  get: function () {
	    return _header.hasSymmetricEncryption;
	  }
	});
	Object.defineProperty(exports, 'hasAsymmetricEncryption', {
	  enumerable: true,
	  get: function () {
	    return _header.hasAsymmetricEncryption;
	  }
	});
	Object.defineProperty(exports, 'getAsymmetricEncryptionParams', {
	  enumerable: true,
	  get: function () {
	    return _header.getAsymmetricEncryptionParams;
	  }
	});
	
	var _data = __webpack_require__(24);
	
	Object.defineProperty(exports, 'decryptData', {
	  enumerable: true,
	  get: function () {
	    return _data.decrypt;
	  }
	});
	
	var _file = __webpack_require__(25);
	
	Object.defineProperty(exports, 'decryptFile', {
	  enumerable: true,
	  get: function () {
	    return _file.decrypt;
	  }
	});
	
	var _index = __webpack_require__(47);
	
	Object.defineProperty(exports, 'deriveKeyAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.deriveKey;
	  }
	});
	Object.defineProperty(exports, 'createRandomAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.createRandom;
	  }
	});
	Object.defineProperty(exports, 'createKeyAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.createKey;
	  }
	});
	Object.defineProperty(exports, 'createIVAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.createIV;
	  }
	});
	Object.defineProperty(exports, 'createAsymmetricKeysAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.createAsymmetricKeys;
	  }
	});
	Object.defineProperty(exports, 'createAsymmetricKeysECDSAAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.createAsymmetricKeysECDSA;
	  }
	});
	Object.defineProperty(exports, 'signWithECDSAPrivateKeyAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.signWithECDSAPrivateKey;
	  }
	});
	Object.defineProperty(exports, 'verifyWithECDSAPublicKeyAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.verifyWithECDSAPublicKey;
	  }
	});
	Object.defineProperty(exports, 'encryptTextAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.encryptText;
	  }
	});
	Object.defineProperty(exports, 'decryptTextAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptText;
	  }
	});
	Object.defineProperty(exports, 'encryptObjectAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.encryptObject;
	  }
	});
	Object.defineProperty(exports, 'decryptObjectAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptObject;
	  }
	});
	Object.defineProperty(exports, 'encryptKeyAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.encryptKey;
	  }
	});
	Object.defineProperty(exports, 'decryptKeyAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptKey;
	  }
	});
	Object.defineProperty(exports, 'encryptRecordAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.encryptRecord;
	  }
	});
	Object.defineProperty(exports, 'decryptRecordAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptRecord;
	  }
	});
	Object.defineProperty(exports, 'decryptKeyWithSymmetricEncryptionAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptKeyWithSymmetricEncryption;
	  }
	});
	Object.defineProperty(exports, 'decryptKeyWithAsymmetricEncryptionAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptKeyWithAsymmetricEncryption;
	  }
	});
	Object.defineProperty(exports, 'decryptDataAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptData;
	  }
	});
	Object.defineProperty(exports, 'decryptFileAsync', {
	  enumerable: true,
	  get: function () {
	    return _index.decryptFile;
	  }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isPlaceholder = __webpack_require__(21);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(21);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * An optimized, private array `slice` implementation.
	 *
	 * @private
	 * @param {Arguments|Array} args The array or arguments object to consider.
	 * @param {Number} [from=0] The array index to slice from, inclusive.
	 * @param {Number} [to=args.length] The array index to slice to, exclusive.
	 * @return {Array} A new, sliced array.
	 * @example
	 *
	 *      _slice([1, 2, 3, 4, 5], 1, 3); //=> [2, 3]
	 *
	 *      var firstThreeArgs = function(a, b, c, d) {
	 *        return _slice(arguments, 0, 3);
	 *      };
	 *      firstThreeArgs(1, 2, 3, 4); //=> [1, 2, 3]
	 */
	module.exports = function _slice(args, from, to) {
	  switch (arguments.length) {
	    case 1: return _slice(args, 0, args.length);
	    case 2: return _slice(args, from, args.length);
	    default:
	      var list = [];
	      var idx = 0;
	      var len = Math.max(0, Math.min(args.length, to) - from);
	      while (idx < len) {
	        list[idx] = args[from + idx];
	        idx += 1;
	      }
	      return list;
	  }
	};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createRecord = createRecord;
	exports.createHeaderWrapper = createHeaderWrapper;
	exports.createRecordMetadata = createRecordMetadata;
	exports.createHeaderWrapperEncryptionParams = createHeaderWrapperEncryptionParams;
	exports.createBlock = createBlock;
	exports.createHeader = createHeader;
	exports.createSymmetricEncryptionWrapper = createSymmetricEncryptionWrapper;
	exports.createAsymmetricEncryptionWrapper = createAsymmetricEncryptionWrapper;
	exports.createFilesEncryptionParams = createFilesEncryptionParams;
	exports.createFilesStorageParams = createFilesStorageParams;
	exports.createData = createData;
	exports.createFileMetadata = createFileMetadata;
	exports.createEncryptedFile = createEncryptedFile;
	exports.createEncryptionParams = createEncryptionParams;
	exports.createDerivationParams = createDerivationParams;
	/**
	 * Record
	 *
	 * @typedef {Object} Record
	 * @property {HeaderWrapper} headerWrapper
	 * @property {HeaderWrapperEncryptionParams} headerWrapperEncryptionParams
	 * @property {Block[]} blocks - consists of the data and files keys only. the header is stored inside the encrypted headerWrapper.
	 * @protected
	 * @example
	 *  const record = {
	 *    headerWrapper: {
	 *      metadata: {
	 *        type: 'standard',
	 *        id: 'id',
	 *        creator: 'creator',
	 *        personalPage: 'personalPage',
	 *        signature: 'signature',
	 *        signatureKeyVersion: 'signatureKeyVersion',
	 *        timestamp: 1488992366155,
	 *        timezoneOffset: 120,
	 *        isOnce: false,
	 *        expiration: 1488992300000,
	 *        subject: 'subject',
	 *        origin: 'origin',
	 *        custom: {
	 *          key1: value1,
	 *          key2: value2,
	 *          ...
	 *        }
	 *      },
	 *      blocks: [
	 *        {
	 *          symmetricEncryption: [
	 *            {
	 *              hint: 'hint',
	 *              derivationParams: {
	 *                iterations: 'iterations',
	 *                salt: 'salt'
	 *              },
	 *              encryptionParams: {
	 *                iv: 'iv',
	 *                mode: 'gcm',
	 *                ts: 128,
	 *                adata: 'cryptolize'
	 *              },
	 *              encryptedKey: 'encryptedKey'
	 *            },
	 *            ...
	 *          ],
	 *          asymmetricEncryption: [
	 *            {
	 *              id: 'id',
	 *              version: 'version',
	 *              tag: 'tag',
	 *              encryptionParams: {
	 *                iv: 'iv',
	 *                mode: 'gcm',
	 *                ts: 128,
	 *                adata: 'cryptolize'
	 *              },
	 *              encryptedKey: 'encryptedKey'
	 *            },
	 *            ...
	 *          ],
	 *          dataEncryptionParams: {
	 *            iv: 'iv',
	 *            mode: 'gcm',
	 *            ts: 128,
	 *            adata: 'cryptolize'
	 *          },
	 *          filesEncryptionParams: [
	 *            {
	 *              id: 'id',
	 *              encryptionParams: {
	 *                iv: 'iv',
	 *                mode: 'gcm',
	 *                ts: 128,
	 *                adata: 'cryptolize'
	 *              }
	 *            },
	 *            ...
	 *          ],
	 *          filesStorageParams: [
	 *            {
	 *              id: 'id',
	 *              path: 'path',
	 *              service: 'service'
	 *            },
	 *            ...
	 *          ]
	 *        }
	 *        ...
	 *      ]
	 *    },
	 *    headerWrapperEncryptionParams: {
	 *      id: 'id',
	 *      tag: 'tag',
	 *      encryptionParams: {
	 *        iv: 'iv',
	 *        mode: 'gcm',
	 *        ts: 128,
	 *        adata: 'cryptolize'
	 *      },
	 *    },
	 *    blocks: [
	 *      {
	 *        data: {
	 *          text: 'text',
	 *          files: [
	 *            {
	 *              name: 'name',
	 *              size: 'size',
	 *              type: 'type',
	 *              id: 'id'
	 *            },
	 *            ...
	 *          ]
	 *        },
	 *        files: [
	 *          {
	 *            id: 'id',
	 *            data: 'data'
	 *          },
	 *          ...
	 *        ]
	 *      },
	 *      ...
	 *    ]
	 *  }
	 */
	
	/**
	 * Create record
	 *
	 * @param {HeaderWrapper} headerWrapper
	 * @param {HeaderWrapperEncryptionParams} headerWrapperEncryptionParams
	 * @param {Block[]} blocks
	 * @return {Record}
	 * @private
	 */
	function createRecord(headerWrapper, headerWrapperEncryptionParams, blocks) {
	  return {
	    headerWrapper: headerWrapper,
	    headerWrapperEncryptionParams: headerWrapperEncryptionParams,
	    blocks: blocks
	  };
	}
	
	/**
	 * Header wrapper
	 *
	 * @typedef {Object} HeaderWrapper
	 * @property {RecordMetadata} metadata
	 * @property {Header[]} blocks
	 * @protected
	 */
	
	/**
	 * Create header wrapper
	 *
	 * @param {RecordMetadata} metadata
	 * @param {Header[]} blocks
	 * @return {HeaderWrapper}
	 * @private
	 */
	function createHeaderWrapper(metadata, blocks) {
	  return {
	    metadata: metadata,
	    blocks: blocks
	  };
	}
	
	/**
	 * RecordMetadata
	 *
	 * @typedef {Object} RecordMetadata
	 * @property {String} type
	 * @property {String} id
	 * @property {String} [creator]
	 * @property {String} [personalPage]
	 * @property {Base64UrlString} [signature]
	 * @property {String} [signatureKeyVersion]
	 * @property {Number} timestamp
	 * @property {Number} timezoneOffset
	 * @property {Boolean} isOnce
	 * @property {Number} [expiration]
	 * @property {String} [subject]
	 * @property {String} [origin]
	 * @property {Object} [custom]
	 * @protected
	 */
	
	/**
	 * Create record metadata
	 *
	 * @param {String} id
	 * @param {String} [creator]
	 * @param {String} [personalPage]
	 * @param {Base64UrlString} [signature]
	 * @param {String} [signatureKeyVersion]
	 * @param {Number} timestamp
	 * @param {Number} timezoneOffset
	 * @param {Boolean} isOnce
	 * @param {Number} [expiration]
	 * @param {String} [subject]
	 * @param {String} [origin]
	 * @param {Object} [custom]
	 * @return {RecordMetadata}
	 * @public
	 */
	function createRecordMetadata(id, creator, personalPage, signature, signatureKeyVersion, timestamp, timezoneOffset, isOnce, expiration, subject, origin, custom) {
	  return {
	    type: 'standard',
	    id: id,
	    creator: creator,
	    personalPage: personalPage,
	    signature: signature,
	    signatureKeyVersion: signatureKeyVersion,
	    timestamp: timestamp,
	    timezoneOffset: timezoneOffset,
	    isOnce: isOnce,
	    expiration: expiration,
	    subject: subject,
	    origin: origin,
	    custom: custom
	  };
	}
	
	/**
	 * Header wrapper encryption params
	 *
	 * @typedef {Object} HeaderWrapperEncryptionParams
	 * @property {String} keyId
	 * @property {Base64UrlString} tag
	 * @property {SymmetricEncryptionParams} encryptionParams
	 * @protected
	 */
	
	/**
	 * Create header wrapper encryption params
	 *
	 * @param {String} id
	 * @param {Base64UrlString} tag
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @return {HeaderEncryptionWrapper}
	 * @private
	 */
	function createHeaderWrapperEncryptionParams(id, tag, encryptionParams) {
	  return {
	    id: id,
	    tag: tag,
	    encryptionParams: encryptionParams
	  };
	}
	
	/**
	 * Block
	 *
	 * @typedef {Object} Block
	 * @property {Header} header
	 * @property {Data} data encrypted and represented by Base64UrlString
	 * @property {EncryptedFile[]} files
	 * @protected
	 */
	
	/**
	 * Create block
	 *
	 * @param {Header} header
	 * @param {Data} data
	 * @param {EncryptedFile[]} files
	 * @return {Block}
	 * @private
	 */
	function createBlock(header, data, files) {
	  return {
	    header: header,
	    data: data,
	    files: files
	  };
	}
	
	/**
	 * Header
	 *
	 * @typedef {Object} Header
	 * @property {SymmetricEncryptionWrapper[]} symmetricEncryption
	 * @property {AsymmetricEncryptionWrapper[]} asymmetricEncryption
	 * @property {SymmetricEncryptionParams} encryptionParams
	 * @property {FilesEncryptionParams[]} filesEncryptionParams
	 * @property {FilesStorageParams[]} filesStorageParams
	 * @protected
	 */
	
	/**
	 * Create header
	 *
	 * @param {SymmetricEncryptionWrapper[]} symmetricEncryption
	 * @param {AsymmetricEncryptionWrapper[]} asymmetricEncryption
	 * @param {SymmetricEncryptionParams} dataEncryptionParams
	 * @param {FilesEncryptionParams[]} filesEncryptionParams
	 * @param {FilesStorageParams[]} filesStorageParams
	 * @return {Header}
	 * @private
	 */
	function createHeader(symmetricEncryption, asymmetricEncryption, dataEncryptionParams, filesEncryptionParams, filesStorageParams) {
	  return {
	    symmetricEncryption: symmetricEncryption,
	    asymmetricEncryption: asymmetricEncryption,
	    dataEncryptionParams: dataEncryptionParams,
	    filesEncryptionParams: filesEncryptionParams,
	    filesStorageParams: filesStorageParams
	  };
	}
	
	/**
	 * Symmetric encryption wrapper
	 *
	 * @typedef {Object} SymmetricEncryptionWrapper
	 * @property {String} hint
	 * @property {DerivationParams} derivationParams
	 * @property {SymmetricEncryptionParams} encryptionParams
	 * @property {Base64UrlString} encryptedKey
	 * @protected
	 */
	
	/**
	 * Create symmetric encryption wrapper
	 *
	 * @param {String} hint
	 * @param {DerivationParams} derivationParams
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @param {Base64UrlString} encryptedKey
	 * @return {SymmetricEncryptionWrapper}
	 * @private
	 */
	function createSymmetricEncryptionWrapper(hint, derivationParams, encryptionParams, encryptedKey) {
	  return {
	    hint: hint,
	    derivationParams: derivationParams,
	    encryptionParams: encryptionParams,
	    encryptedKey: encryptedKey
	  };
	}
	
	/**
	 * Asymmetric encryption wrapper
	 *
	 * @typedef {Object} AsymmetricEncryptionWrapper
	 * @property {String} id
	 * @property {String} version
	 * @property {Base64UrlString} tag
	 * @property {SymmetricEncryptionParams} encryptionParams
	 * @property {Base64UrlString} encryptedKey
	 * @protected
	 */
	
	/**
	 * Create asymmetric encryption wrapper
	 *
	 * @param {String} id
	 * @param {String} version
	 * @param {Base64UrlString} tag
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @param {Base64UrlString} encryptedKey
	 * @return {AsymmetricEncryptionWrapper}
	 * @private
	 */
	function createAsymmetricEncryptionWrapper(id, version, tag, encryptionParams, encryptedKey) {
	  return {
	    id: id,
	    version: version,
	    tag: tag,
	    encryptionParams: encryptionParams,
	    encryptedKey: encryptedKey
	  };
	}
	
	/**
	 * Files encryption params
	 *
	 * @typedef {Object} FilesEncryptionParams
	 * @property {String} id
	 * @property {SymmetricEncryptionParams} encryptionParams
	 * @protected
	 */
	
	/**
	 * Create files encryption params
	 *
	 * @param {String} id
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @return {FilesEncryptionParams}
	 * @private
	 */
	function createFilesEncryptionParams(id, encryptionParams) {
	  return {
	    id: id,
	    encryptionParams: encryptionParams
	  };
	}
	
	/**
	 * Files storage params
	 *
	 * @typedef {Object} FilesStorageParams
	 * @property {String} id
	 * @property {String} path
	 * @property {String} service
	 * @protected
	 */
	
	/**
	 * Create files storage params
	 *
	 * @param {String} id
	 * @param {String} path
	 * @param {String} service
	 * @return {FilesStorageParams}
	 * @private
	 */
	function createFilesStorageParams(id, path, service) {
	  return {
	    id: id,
	    path: path,
	    service: service
	  };
	}
	
	/**
	 * Data
	 *
	 * @typedef {Object} Data
	 * @property {String} text
	 * @property {FileMetadata[]} files
	 * @protected
	 */
	
	/**
	 * Create Data
	 *
	 * @param {String} text
	 * @param {FileMetadata[]} files
	 * @return {Data}
	 * @private
	 */
	function createData(text, files) {
	  return {
	    text: text,
	    files: files
	  };
	}
	
	/**
	 * File metadata
	 *
	 * @typedef {Object} FileMetadata
	 * @property {String} name
	 * @property {Number} size
	 * @property {String} type
	 * @property {String} id
	 * @protected
	 */
	
	/**
	 * Create file metadata
	 *
	 * @param {String} name
	 * @param {Number} size
	 * @param {String} type
	 * @param {String} id
	 * @return {FileMetadata}
	 * @private
	 */
	function createFileMetadata(name, size, type, id) {
	  return {
	    name: name,
	    size: size,
	    type: type,
	    id: id
	  };
	}
	
	/**
	 * Encrypted file
	 *
	 * @typedef {Object} EncryptedFile
	 * @property {String} id
	 * @property {String} path
	 * @property {String} service
	 * @property {ArrayBuffer} data
	 * @protected
	 */
	
	/**
	 * Create file
	 *
	 * @param {String} id
	 * @param {String} path
	 * @param {String} service
	 * @param {ArrayBuffer} data
	 * @return {EncryptedFile}
	 * @private
	 */
	function createEncryptedFile(id, path, service, data) {
	  return {
	    id: id,
	    path: path,
	    service: service,
	    data: data
	  };
	}
	
	/**
	 * Symmetric encryption params
	 *
	 * @typedef {Object} SymmetricEncryptionParams
	 * @property {Base64UrlString} iv
	 * @property {String} mode
	 * @property {Number} ts
	 * @property {String} adata
	 * @protected
	 */
	
	/**
	 * Create encryption params
	 *
	 * @param {Base64UrlString} iv
	 * @return {SymmetricEncryptionParams}
	 * @public
	 */
	function createEncryptionParams(iv) {
	  return {
	    iv: iv,
	    mode: 'gcm',
	    ts: 128,
	    adata: 'cryptolize'
	  };
	}
	
	/**
	 * Derivation params
	 *
	 * @typedef {Object} DerivationParams
	 * @property {Number} iterations
	 * @property {Base64UrlString} salt
	 * @protected
	 */
	
	/**
	 * Create derivation params
	 *
	 * @param {Number} iterations
	 * @param {Base64UrlString} salt
	 * @return {DerivationParams}
	 * @private
	 */
	function createDerivationParams(iterations, salt) {
	  return {
	    iterations: iterations,
	    salt: salt
	  };
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _curry2 = __webpack_require__(1);
	var _isPlaceholder = __webpack_require__(21);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ = __webpack_require__(16);
	
	var _2 = _interopRequireDefault(_);
	
	var _curry = __webpack_require__(5);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _constructN = __webpack_require__(57);
	
	var _constructN2 = _interopRequireDefault(_constructN);
	
	var _prop = __webpack_require__(14);
	
	var _prop2 = _interopRequireDefault(_prop);
	
	var _compose = __webpack_require__(8);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	exports.encryptText = encryptText;
	exports.encryptObject = encryptObject;
	exports.encryptFile = encryptFile;
	exports.encryptKey = encryptKey;
	exports.decryptText = decryptText;
	exports.decryptObject = decryptObject;
	exports.decryptFile = decryptFile;
	exports.decryptKey = decryptKey;
	
	var _sjcl = __webpack_require__(11);
	
	var _sjcl2 = _interopRequireDefault(_sjcl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Encrypt bitArray
	 *
	 * @param {bitArray} data
	 * @param {Base64UrlString} key
	 * @param {Object} $2 encryption params
	 * @param {Base64UrlString} $2.iv initialization vector
	 * @param {String} $2.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} $2.ts tag size [64, 96, 128]
	 * @param {String} $2.adata authenticated data to associate with the data
	 * @return {bitArray} the encrypted data
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function _encrypt(data, key, _ref) {
	  var iv = _ref.iv,
	      mode = _ref.mode,
	      ts = _ref.ts,
	      adata = _ref.adata;
	
	  return _sjcl2.default.mode[mode].encrypt(new _sjcl2.default.cipher.aes(_sjcl2.default.codec.base64url.toBits(key)), // eslint-disable-line new-cap
	  data, _sjcl2.default.codec.base64url.toBits(iv), _sjcl2.default.codec.utf8String.toBits(adata), ts);
	}
	
	/**
	 * Decrypt bitArray
	 *
	 * @param {bitArray} data
	 * @param {Base64UrlString} key
	 * @param {Object} $2 encryption params
	 * @param {Base64UrlString} $2.iv initialization vector
	 * @param {String} $2.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} $2.ts tag size [64, 96, 128]
	 * @param {String} $2.adata authenticated data to associate with the data
	 * @return {bitArray} the decrypted data
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @private
	 */
	function _decrypt(data, key, _ref2) {
	  var iv = _ref2.iv,
	      mode = _ref2.mode,
	      ts = _ref2.ts,
	      adata = _ref2.adata;
	
	  return _sjcl2.default.mode[mode].decrypt(new _sjcl2.default.cipher.aes(_sjcl2.default.codec.base64url.toBits(key)), // eslint-disable-line new-cap
	  data, _sjcl2.default.codec.base64url.toBits(iv), _sjcl2.default.codec.utf8String.toBits(adata), ts);
	}
	
	/**
	 * Encrypt text
	 *
	 * @param {String} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {Base64UrlString} the encrypted data
	 * @throws {Error} if a parameter is invalid
	 * @public
	 */
	function encryptText(data, key, encryptionParams) {
	  return _sjcl2.default.codec.base64url.fromBits(_encrypt(_sjcl2.default.codec.utf8String.toBits(data), key, encryptionParams));
	}
	
	/**
	 * Encrypt object
	 *
	 * @param {Object} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {Base64UrlString} the encrypted data
	 * @throws {Error} if a parameter is invalid
	 * @public
	 */
	function encryptObject(data, key, encryptionParams) {
	  return encryptText(JSON.stringify(data), key, encryptionParams);
	}
	
	/**
	 * Encrypt file
	 *
	 * @param {ArrayBuffer} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {ArrayBuffer} the encrypted data
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encryptFile(data, key, encryptionParams) {
	  return (0, _compose2.default)((0, _prop2.default)('buffer'), (0, _constructN2.default)(1, Uint8Array), _sjcl2.default.codec.bytes.fromBits, (0, _curry2.default)(_encrypt)(_2.default, key, encryptionParams), _sjcl2.default.codec.bytes.toBits, (0, _constructN2.default)(1, Uint8Array))(data);
	}
	
	/**
	 * Encrypt key
	 *
	 * @param {Base64UrlString} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {Base64UrlString} the encrypted data
	 * @throws {Error} if a parameter is invalid
	 * @public
	 */
	function encryptKey(data, key, encryptionParams) {
	  return _sjcl2.default.codec.base64url.fromBits(_encrypt(_sjcl2.default.codec.base64url.toBits(data), key, encryptionParams));
	}
	
	/**
	 * Decrypt text
	 *
	 * @param {Base64UrlString} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {String} the decrypted data
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @public
	 */
	function decryptText(data, key, encryptionParams) {
	  return _sjcl2.default.codec.utf8String.fromBits(_decrypt(_sjcl2.default.codec.base64url.toBits(data), key, encryptionParams));
	}
	
	/**
	 * Decrypt object
	 *
	 * @param {Base64UrlString} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {Object} the decrypted data
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @public
	 */
	function decryptObject(data, key, encryptionParams) {
	  return JSON.parse(decryptText(data, key, encryptionParams));
	}
	
	/**
	 * Decrypt file
	 *
	 * @param {ArrayBuffer} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {ArrayBuffer} the decrypted data
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @private
	 */
	function decryptFile(data, key, encryptionParams) {
	  return (0, _compose2.default)((0, _prop2.default)('buffer'), (0, _constructN2.default)(1, Uint8Array), _sjcl2.default.codec.bytes.fromBits, (0, _curry2.default)(_decrypt)(_2.default, key, encryptionParams), _sjcl2.default.codec.bytes.toBits, (0, _constructN2.default)(1, Uint8Array))(data);
	}
	
	/**
	 * Decrypt key
	 *
	 * @param {Base64UrlString} data
	 * @param {Base64UrlString} key
	 * @param {Object} encryptionParams
	 * @param {Base64UrlString} encryptionParams.iv initialization vector
	 * @param {String} encryptionParams.mode aes encryption mode ['ccm', 'gcm', 'ocb2']
	 * @param {Number} encryptionParams.ts tag size [64, 96, 128]
	 * @param {String} encryptionParams.adata authenticated data to associate with the data
	 * @return {Base64UrlString} the decrypted data
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @public
	 */
	function decryptKey(data, key, encryptionParams) {
	  return _sjcl2.default.codec.base64url.fromBits(_decrypt(_sjcl2.default.codec.base64url.toBits(data), key, encryptionParams));
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(104);
	var reverse = __webpack_require__(110);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var f = R.compose(R.inc, R.negate, Math.pow);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(12);
	var _curry1 = __webpack_require__(2);
	var _curry2 = __webpack_require__(1);
	var _curryN = __webpack_require__(72);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(8);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _evolve = __webpack_require__(61);
	
	var _evolve2 = _interopRequireDefault(_evolve);
	
	exports.createAsymmetricKeys = createAsymmetricKeys;
	exports.createSymmetricEncryptionKeyFromPublicKey = createSymmetricEncryptionKeyFromPublicKey;
	exports.createSymmetricEncryptionKeyFromPrivateKey = createSymmetricEncryptionKeyFromPrivateKey;
	exports.createAsymmetricKeysECDSA = createAsymmetricKeysECDSA;
	exports.signWithECDSAPrivateKey = signWithECDSAPrivateKey;
	exports.verifyWithECDSAPublicKey = verifyWithECDSAPublicKey;
	
	var _sjcl = __webpack_require__(11);
	
	var _sjcl2 = _interopRequireDefault(_sjcl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function convertKeyFromHexToBase64(key, prop) {
	  return (0, _evolve2.default)(_defineProperty({}, prop, (0, _compose2.default)(_sjcl2.default.codec.base64url.fromBits, _sjcl2.default.codec.hex.toBits)))(key);
	}
	
	function convertKeyFromBase64ToHex(key, prop) {
	  return (0, _evolve2.default)(_defineProperty({}, prop, (0, _compose2.default)(_sjcl2.default.codec.hex.fromBits, _sjcl2.default.codec.base64url.toBits)))(key);
	}
	
	/**
	 * Create ECC (P-521 NIST curve) public and private keys
	 *
	 * @param {ElGamalPrivateKey} [privateKey] create the keys from specific private key
	 * @return {{public: ElGamalPublicKey, private: PrivateKey}}
	 * @throws {Error} if a parameter is invalid or generator isn't seeded
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  console.log(keys.public)
	 *  console.log(keys.private)
	 */
	function createAsymmetricKeys(privateKey) {
	  var keys = _sjcl2.default.ecc.elGamal.generateKeys(_sjcl2.default.ecc.curves.c521, 6, privateKey && _sjcl2.default.bn.fromBits(_sjcl2.default.ecc.deserialize(convertKeyFromBase64ToHex(JSON.parse(_sjcl2.default.codec.utf8String.fromBits(_sjcl2.default.codec.base64url.toBits(privateKey))), 'exponent')).get()));
	  return {
	    public: _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.codec.utf8String.toBits(JSON.stringify(convertKeyFromHexToBase64(keys.pub.serialize(), 'point')))),
	    private: _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.codec.utf8String.toBits(JSON.stringify(convertKeyFromHexToBase64(keys.sec.serialize(), 'exponent'))))
	  };
	}
	
	/**
	 * Create AES encryption key from public key
	 *
	 * @param {ElGamalPublicKey} publicKey
	 * @return {{key: Base64UrlString, tag: Base64UrlString}} encryption params
	 * @throws {Error} if a parameter is invalid or generator isn't seeded
	 * @private
	 */
	function createSymmetricEncryptionKeyFromPublicKey(publicKey) {
	  return (0, _evolve2.default)({ key: _sjcl2.default.codec.base64url.fromBits, tag: _sjcl2.default.codec.base64url.fromBits }, _sjcl2.default.ecc.deserialize(convertKeyFromBase64ToHex(JSON.parse(_sjcl2.default.codec.utf8String.fromBits(_sjcl2.default.codec.base64url.toBits(publicKey))), 'point')).kem());
	}
	
	/**
	 * Create AES encryption key from private key
	 *
	 * @param {ElGamalPrivateKey} privateKey
	 * @param {Base64UrlString} tag the tag to generate the symmetrical key from
	 * @return {Base64UrlString}
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function createSymmetricEncryptionKeyFromPrivateKey(privateKey, tag) {
	  return _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.ecc.deserialize(convertKeyFromBase64ToHex(JSON.parse(_sjcl2.default.codec.utf8String.fromBits(_sjcl2.default.codec.base64url.toBits(privateKey))), 'exponent')).unkem(_sjcl2.default.codec.base64url.toBits(tag)));
	}
	
	/**
	 * Create ECC (P-521 NIST curve) public and private keys for ECDSA
	 *
	 * @param {ECDSAPrivateKey} [privateKey] create the keys from specific private key
	 * @return {{public: PublicKey, private: PrivateKey}}
	 * @throws {Error} if a parameter is invalid or generator isn't seeded
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeysECDSA()
	 *  console.log(keys.public)
	 *  console.log(keys.private)
	 */
	function createAsymmetricKeysECDSA(privateKey) {
	  var keys = _sjcl2.default.ecc.ecdsa.generateKeys(_sjcl2.default.ecc.curves.c521, 6, privateKey && _sjcl2.default.bn.fromBits(_sjcl2.default.ecc.deserialize(convertKeyFromBase64ToHex(JSON.parse(_sjcl2.default.codec.utf8String.fromBits(_sjcl2.default.codec.base64url.toBits(privateKey))), 'exponent')).get()));
	  return {
	    public: _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.codec.utf8String.toBits(JSON.stringify(convertKeyFromHexToBase64(keys.pub.serialize(), 'point')))),
	    private: _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.codec.utf8String.toBits(JSON.stringify(convertKeyFromHexToBase64(keys.sec.serialize(), 'exponent'))))
	  };
	}
	
	/**
	 * Sign text with ECDSA private key
	 *
	 * @param {ECDSAPrivateKey} privateKey the key to sign with
	 * @param {String} text the text to sign
	 * @return {Base64UrlString}
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeysECDSA()
	 *  const signature = CryptolizeCore.signWithECDSAPrivateKey(keys.private, 'text to sign')
	 */
	function signWithECDSAPrivateKey(privateKey, text) {
	  return _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.ecc.deserialize(convertKeyFromBase64ToHex(JSON.parse(_sjcl2.default.codec.utf8String.fromBits(_sjcl2.default.codec.base64url.toBits(privateKey))), 'exponent')).sign(_sjcl2.default.hash.sha512.hash(text)));
	}
	
	/**
	 * Verify text with ECDSA public key
	 *
	 * @param {ECDSAPublicKey} publicKey the key to verify with
	 * @param {String} text the text to verify
	 * @param {Base64UrlString} signature the signature to verify with
	 * @return {Boolean}
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeysECDSA()
	 *  const signature = CryptolizeCore.signWithECDSAPrivateKey(keys.private, 'text to sign')
	 *  const isOk = CryptolizeCore.verifyWithECDSAPublicKey(keys.public, 'text to sign', signature)
	 */
	function verifyWithECDSAPublicKey(publicKey, text, signature) {
	  try {
	    return _sjcl2.default.ecc.deserialize(convertKeyFromBase64ToHex(JSON.parse(_sjcl2.default.codec.utf8String.fromBits(_sjcl2.default.codec.base64url.toBits(publicKey))), 'point')).verify(_sjcl2.default.hash.sha512.hash(text), _sjcl2.default.codec.base64url.toBits(signature));
	  } catch (e) {
	    return false;
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	"use strict";var sjcl={cipher:{},hash:{},keyexchange:{},mode:{},misc:{},codec:{},exception:{corrupt:function(a){this.toString=function(){return"CORRUPT: "+this.message};this.message=a},invalid:function(a){this.toString=function(){return"INVALID: "+this.message};this.message=a},bug:function(a){this.toString=function(){return"BUG: "+this.message};this.message=a},notReady:function(a){this.toString=function(){return"NOT READY: "+this.message};this.message=a}}};
	"undefined"!==typeof module&&module.exports&&(module.exports=sjcl);"function"===typeof define&&define([],function(){return sjcl});
	sjcl.cipher.aes=function(a){this.D[0][0][0]||this.K();var b,c,d,e,f=this.D[0][4],g=this.D[1];b=a.length;var h=1;if(4!==b&&6!==b&&8!==b)throw new sjcl.exception.invalid("invalid aes key size");this.f=[d=a.slice(0),e=[]];for(a=b;a<4*b+28;a++){c=d[a-1];if(0===a%b||8===b&&4===a%b)c=f[c>>>24]<<24^f[c>>16&255]<<16^f[c>>8&255]<<8^f[c&255],0===a%b&&(c=c<<8^c>>>24^h<<24,h=h<<1^283*(h>>7));d[a]=d[a-b]^c}for(b=0;a;b++,a--)c=d[b&3?a:a-4],e[b]=4>=a||4>b?c:g[0][f[c>>>24]]^g[1][f[c>>16&255]]^g[2][f[c>>8&255]]^g[3][f[c&
	255]]};
	sjcl.cipher.aes.prototype={encrypt:function(a){return aa(this,a,0)},decrypt:function(a){return aa(this,a,1)},D:[[[],[],[],[],[]],[[],[],[],[],[]]],K:function(){var a=this.D[0],b=this.D[1],c=a[4],d=b[4],e,f,g,h=[],k=[],l,n,m,p;for(e=0;0x100>e;e++)k[(h[e]=e<<1^283*(e>>7))^e]=e;for(f=g=0;!c[f];f^=l||1,g=k[g]||1)for(m=g^g<<1^g<<2^g<<3^g<<4,m=m>>8^m&255^99,c[f]=m,d[m]=f,n=h[e=h[l=h[f]]],p=0x1010101*n^0x10001*e^0x101*l^0x1010100*f,n=0x101*h[m]^0x1010100*m,e=0;4>e;e++)a[e][f]=n=n<<24^n>>>8,b[e][m]=p=p<<24^p>>>8;for(e=
	0;5>e;e++)a[e]=a[e].slice(0),b[e]=b[e].slice(0)}};
	function aa(a,b,c){if(4!==b.length)throw new sjcl.exception.invalid("invalid aes block size");var d=a.f[c],e=b[0]^d[0],f=b[c?3:1]^d[1],g=b[2]^d[2];b=b[c?1:3]^d[3];var h,k,l,n=d.length/4-2,m,p=4,q=[0,0,0,0];h=a.D[c];a=h[0];var r=h[1],B=h[2],D=h[3],C=h[4];for(m=0;m<n;m++)h=a[e>>>24]^r[f>>16&255]^B[g>>8&255]^D[b&255]^d[p],k=a[f>>>24]^r[g>>16&255]^B[b>>8&255]^D[e&255]^d[p+1],l=a[g>>>24]^r[b>>16&255]^B[e>>8&255]^D[f&255]^d[p+2],b=a[b>>>24]^r[e>>16&255]^B[f>>8&255]^D[g&255]^d[p+3],p+=4,e=h,f=k,g=l;for(m=
	0;4>m;m++)q[c?3&-m:m]=C[e>>>24]<<24^C[f>>16&255]<<16^C[g>>8&255]<<8^C[b&255]^d[p++],h=e,e=f,f=g,g=b,b=h;return q}
	sjcl.bitArray={bitSlice:function(a,b,c){a=sjcl.bitArray.ca(a.slice(b/32),32-(b&31)).slice(1);return void 0===c?a:sjcl.bitArray.clamp(a,c-b)},extract:function(a,b,c){var d=Math.floor(-b-c&31);return((b+c-1^b)&-32?a[b/32|0]<<32-d^a[b/32+1|0]>>>d:a[b/32|0]>>>d)&(1<<c)-1},concat:function(a,b){if(0===a.length||0===b.length)return a.concat(b);var c=a[a.length-1],d=sjcl.bitArray.getPartial(c);return 32===d?a.concat(b):sjcl.bitArray.ca(b,d,c|0,a.slice(0,a.length-1))},bitLength:function(a){var b=a.length;
	return 0===b?0:32*(b-1)+sjcl.bitArray.getPartial(a[b-1])},clamp:function(a,b){if(32*a.length<b)return a;a=a.slice(0,Math.ceil(b/32));var c=a.length;b=b&31;0<c&&b&&(a[c-1]=sjcl.bitArray.partial(b,a[c-1]&2147483648>>b-1,1));return a},partial:function(a,b,c){return 32===a?b:(c?b|0:b<<32-a)+0x10000000000*a},getPartial:function(a){return Math.round(a/0x10000000000)||32},equal:function(a,b){if(sjcl.bitArray.bitLength(a)!==sjcl.bitArray.bitLength(b))return!1;var c=0,d;for(d=0;d<a.length;d++)c|=a[d]^b[d];
	return 0===c},ca:function(a,b,c,d){var e;e=0;for(void 0===d&&(d=[]);32<=b;b-=32)d.push(c),c=0;if(0===b)return d.concat(a);for(e=0;e<a.length;e++)d.push(c|a[e]>>>b),c=a[e]<<32-b;e=a.length?a[a.length-1]:0;a=sjcl.bitArray.getPartial(e);d.push(sjcl.bitArray.partial(b+a&31,32<b+a?c:d.pop(),1));return d},sa:function(a,b){return[a[0]^b[0],a[1]^b[1],a[2]^b[2],a[3]^b[3]]},byteswapM:function(a){var b,c;for(b=0;b<a.length;++b)c=a[b],a[b]=c>>>24|c>>>8&0xff00|(c&0xff00)<<8|c<<24;return a}};
	sjcl.codec.utf8String={fromBits:function(a){var b="",c=sjcl.bitArray.bitLength(a),d,e;for(d=0;d<c/8;d++)0===(d&3)&&(e=a[d/4]),b+=String.fromCharCode(e>>>24),e<<=8;return decodeURIComponent(escape(b))},toBits:function(a){a=unescape(encodeURIComponent(a));var b=[],c,d=0;for(c=0;c<a.length;c++)d=d<<8|a.charCodeAt(c),3===(c&3)&&(b.push(d),d=0);c&3&&b.push(sjcl.bitArray.partial(8*(c&3),d));return b}};
	sjcl.codec.hex={fromBits:function(a){var b="",c;for(c=0;c<a.length;c++)b+=((a[c]|0)+0xf00000000000).toString(16).substr(4);return b.substr(0,sjcl.bitArray.bitLength(a)/4)},toBits:function(a){var b,c=[],d;a=a.replace(/\s|0x/g,"");d=a.length;a=a+"00000000";for(b=0;b<a.length;b+=8)c.push(parseInt(a.substr(b,8),16)^0);return sjcl.bitArray.clamp(c,4*d)}};
	sjcl.codec.base64={X:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",fromBits:function(a,b,c){var d="",e=0,f=sjcl.codec.base64.X,g=0,h=sjcl.bitArray.bitLength(a);c&&(f=f.substr(0,62)+"-_");for(c=0;6*d.length<h;)d+=f.charAt((g^a[c]>>>e)>>>26),6>e?(g=a[c]<<6-e,e+=26,c++):(g<<=6,e-=6);for(;d.length&3&&!b;)d+="=";return d},toBits:function(a,b){a=a.replace(/\s|=/g,"");var c=[],d,e=0,f=sjcl.codec.base64.X,g=0,h;b&&(f=f.substr(0,62)+"-_");for(d=0;d<a.length;d++){h=f.indexOf(a.charAt(d));
	if(0>h)throw new sjcl.exception.invalid("this isn't base64!");26<e?(e-=26,c.push(g^h>>>e),g=h<<32-e):(e+=6,g^=h<<32-e)}e&56&&c.push(sjcl.bitArray.partial(e&56,g,1));return c}};sjcl.codec.base64url={fromBits:function(a){return sjcl.codec.base64.fromBits(a,1,1)},toBits:function(a){return sjcl.codec.base64.toBits(a,1)}};
	sjcl.codec.bytes={fromBits:function(a){var b=[],c=sjcl.bitArray.bitLength(a),d,e;for(d=0;d<c/8;d++)0===(d&3)&&(e=a[d/4]),b.push(e>>>24),e<<=8;return b},toBits:function(a){var b=[],c,d=0;for(c=0;c<a.length;c++)d=d<<8|a[c],3===(c&3)&&(b.push(d),d=0);c&3&&b.push(sjcl.bitArray.partial(8*(c&3),d));return b}};"undefined"===typeof ArrayBuffer&&function(a){a.ArrayBuffer=function(){};a.DataView=function(){}}(this);
	sjcl.codec.arrayBuffer={fromBits:function(a,b,c){var d;b=void 0==b?!0:b;c=c||8;if(0===a.length)return new ArrayBuffer(0);d=sjcl.bitArray.bitLength(a)/8;if(0!==sjcl.bitArray.bitLength(a)%8)throw new sjcl.exception.invalid("Invalid bit size, must be divisble by 8 to fit in an arraybuffer correctly");b&&0!==d%c&&(d+=c-d%c);c=new DataView(new ArrayBuffer(4*a.length));for(b=0;b<a.length;b++)c.setUint32(4*b,a[b]<<32);a=new DataView(new ArrayBuffer(d));if(a.byteLength===c.byteLength)return c.buffer;d=c.byteLength<
	a.byteLength?c.byteLength:a.byteLength;for(b=0;b<d;b++)a.setUint8(b,c.getUint8(b));return a.buffer},toBits:function(a){var b=[],c,d,e;if(0===a.byteLength)return[];d=new DataView(a);c=d.byteLength-d.byteLength%4;for(a=0;a<c;a+=4)b.push(d.getUint32(a));if(0!=d.byteLength%4){e=new DataView(new ArrayBuffer(4));a=0;for(var f=d.byteLength%4;a<f;a++)e.setUint8(a+4-f,d.getUint8(c+a));b.push(sjcl.bitArray.partial(d.byteLength%4*8,e.getUint32(0)))}return b},ta:function(a){function b(a){a=a+"";return 4<=a.length?
	a:Array(4-a.length+1).join("0")+a}a=new DataView(a);for(var c="",d=0;d<a.byteLength;d+=2)0==d%16&&(c+="\n"+d.toString(16)+"\t"),c+=b(a.getUint16(d).toString(16))+" ";void 0===typeof console&&(console=console||{log:function(){}});console.log(c.toUpperCase())}};sjcl.hash.sha256=function(a){this.f[0]||this.K();a?(this.j=a.j.slice(0),this.h=a.h.slice(0),this.g=a.g):this.reset()};sjcl.hash.sha256.hash=function(a){return(new sjcl.hash.sha256).update(a).finalize()};
	sjcl.hash.sha256.prototype={blockSize:512,reset:function(){this.j=this.A.slice(0);this.h=[];this.g=0;return this},update:function(a){"string"===typeof a&&(a=sjcl.codec.utf8String.toBits(a));var b,c=this.h=sjcl.bitArray.concat(this.h,a);b=this.g;a=this.g=b+sjcl.bitArray.bitLength(a);for(b=512+b&-512;b<=a;b+=512)this.I(c.splice(0,16));return this},finalize:function(){var a,b=this.h,c=this.j,b=sjcl.bitArray.concat(b,[sjcl.bitArray.partial(1,1)]);for(a=b.length+2;a&15;a++)b.push(0);b.push(Math.floor(this.g/
	4294967296));for(b.push(this.g|0);b.length;)this.I(b.splice(0,16));this.reset();return c},A:[],f:[],K:function(){function a(a){return 0x100000000*(a-Math.floor(a))|0}var b=0,c=2,d;a:for(;64>b;c++){for(d=2;d*d<=c;d++)if(0===c%d)continue a;8>b&&(this.A[b]=a(Math.pow(c,.5)));this.f[b]=a(Math.pow(c,1/3));b++}},I:function(a){var b,c,d=a.slice(0),e=this.j,f=this.f,g=e[0],h=e[1],k=e[2],l=e[3],n=e[4],m=e[5],p=e[6],q=e[7];for(a=0;64>a;a++)16>a?b=d[a]:(b=d[a+1&15],c=d[a+14&15],b=d[a&15]=(b>>>7^b>>>18^b>>>3^
	b<<25^b<<14)+(c>>>17^c>>>19^c>>>10^c<<15^c<<13)+d[a&15]+d[a+9&15]|0),b=b+q+(n>>>6^n>>>11^n>>>25^n<<26^n<<21^n<<7)+(p^n&(m^p))+f[a],q=p,p=m,m=n,n=l+b|0,l=k,k=h,h=g,g=b+(h&k^l&(h^k))+(h>>>2^h>>>13^h>>>22^h<<30^h<<19^h<<10)|0;e[0]=e[0]+g|0;e[1]=e[1]+h|0;e[2]=e[2]+k|0;e[3]=e[3]+l|0;e[4]=e[4]+n|0;e[5]=e[5]+m|0;e[6]=e[6]+p|0;e[7]=e[7]+q|0}};sjcl.hash.sha512=function(a){this.f[0]||this.K();a?(this.j=a.j.slice(0),this.h=a.h.slice(0),this.g=a.g):this.reset()};sjcl.hash.sha512.hash=function(a){return(new sjcl.hash.sha512).update(a).finalize()};
	sjcl.hash.sha512.prototype={blockSize:1024,reset:function(){this.j=this.A.slice(0);this.h=[];this.g=0;return this},update:function(a){"string"===typeof a&&(a=sjcl.codec.utf8String.toBits(a));var b,c=this.h=sjcl.bitArray.concat(this.h,a);b=this.g;a=this.g=b+sjcl.bitArray.bitLength(a);for(b=1024+b&-1024;b<=a;b+=1024)this.I(c.splice(0,32));return this},finalize:function(){var a,b=this.h,c=this.j,b=sjcl.bitArray.concat(b,[sjcl.bitArray.partial(1,1)]);for(a=b.length+4;a&31;a++)b.push(0);b.push(0);b.push(0);
	b.push(Math.floor(this.g/0x100000000));for(b.push(this.g|0);b.length;)this.I(b.splice(0,32));this.reset();return c},A:[],ma:[12372232,13281083,9762859,1914609,15106769,4090911,4308331,8266105],f:[],oa:[2666018,15689165,5061423,9034684,4764984,380953,1658779,7176472,197186,7368638,14987916,16757986,8096111,1480369,13046325,6891156,15813330,5187043,9229749,11312229,2818677,10937475,4324308,1135541,6741931,11809296,16458047,15666916,11046850,698149,229999,945776,13774844,2541862,12856045,9810911,11494366,
	7844520,15576806,8533307,15795044,4337665,16291729,5553712,15684120,6662416,7413802,12308920,13816008,4303699,9366425,10176680,13195875,4295371,6546291,11712675,15708924,1519456,15772530,6568428,6495784,8568297,13007125,7492395,2515356,12632583,14740254,7262584,1535930,13146278,16321966,1853211,294276,13051027,13221564,1051980,4080310,6651434,14088940,4675607],K:function(){function a(a){return 0x100000000*(a-Math.floor(a))|0}function b(a){return 0x10000000000*(a-Math.floor(a))&255}var c=0,d=2,e;a:for(;80>
	c;d++){for(e=2;e*e<=d;e++)if(0===d%e)continue a;8>c&&(this.A[2*c]=a(Math.pow(d,.5)),this.A[2*c+1]=b(Math.pow(d,.5))<<24|this.ma[c]);this.f[2*c]=a(Math.pow(d,1/3));this.f[2*c+1]=b(Math.pow(d,1/3))<<24|this.oa[c];c++}},I:function(a){var b,c,d=a.slice(0),e=this.j,f=this.f,g=e[0],h=e[1],k=e[2],l=e[3],n=e[4],m=e[5],p=e[6],q=e[7],r=e[8],B=e[9],D=e[10],C=e[11],ea=e[12],P=e[13],fa=e[14],Q=e[15],w=g,u=h,G=k,E=l,H=n,F=m,V=p,I=q,x=r,v=B,R=D,J=C,S=ea,K=P,W=fa,L=Q;for(a=0;80>a;a++){if(16>a)b=d[2*a],c=d[2*a+1];
	else{c=d[2*(a-15)];var t=d[2*(a-15)+1];b=(t<<31|c>>>1)^(t<<24|c>>>8)^c>>>7;var y=(c<<31|t>>>1)^(c<<24|t>>>8)^(c<<25|t>>>7);c=d[2*(a-2)];var z=d[2*(a-2)+1],t=(z<<13|c>>>19)^(c<<3|z>>>29)^c>>>6,z=(c<<13|z>>>19)^(z<<3|c>>>29)^(c<<26|z>>>6),X=d[2*(a-7)],Y=d[2*(a-16)],M=d[2*(a-16)+1];c=y+d[2*(a-7)+1];b=b+X+(c>>>0<y>>>0?1:0);c+=z;b+=t+(c>>>0<z>>>0?1:0);c+=M;b+=Y+(c>>>0<M>>>0?1:0)}d[2*a]=b|=0;d[2*a+1]=c|=0;var X=x&R^~x&S,ga=v&J^~v&K,z=w&G^w&H^G&H,ka=u&E^u&F^E&F,Y=(u<<4|w>>>28)^(w<<30|u>>>2)^(w<<25|u>>>7),
	M=(w<<4|u>>>28)^(u<<30|w>>>2)^(u<<25|w>>>7),la=f[2*a],ha=f[2*a+1],t=L+((x<<18|v>>>14)^(x<<14|v>>>18)^(v<<23|x>>>9)),y=W+((v<<18|x>>>14)^(v<<14|x>>>18)^(x<<23|v>>>9))+(t>>>0<L>>>0?1:0),t=t+ga,y=y+(X+(t>>>0<ga>>>0?1:0)),t=t+ha,y=y+(la+(t>>>0<ha>>>0?1:0)),t=t+c|0,y=y+(b+(t>>>0<c>>>0?1:0));c=M+ka;b=Y+z+(c>>>0<M>>>0?1:0);W=S;L=K;S=R;K=J;R=x;J=v;v=I+t|0;x=V+y+(v>>>0<I>>>0?1:0)|0;V=H;I=F;H=G;F=E;G=w;E=u;u=t+c|0;w=y+b+(u>>>0<t>>>0?1:0)|0}h=e[1]=h+u|0;e[0]=g+w+(h>>>0<u>>>0?1:0)|0;l=e[3]=l+E|0;e[2]=k+G+(l>>>
	0<E>>>0?1:0)|0;m=e[5]=m+F|0;e[4]=n+H+(m>>>0<F>>>0?1:0)|0;q=e[7]=q+I|0;e[6]=p+V+(q>>>0<I>>>0?1:0)|0;B=e[9]=B+v|0;e[8]=r+x+(B>>>0<v>>>0?1:0)|0;C=e[11]=C+J|0;e[10]=D+R+(C>>>0<J>>>0?1:0)|0;P=e[13]=P+K|0;e[12]=ea+S+(P>>>0<K>>>0?1:0)|0;Q=e[15]=Q+L|0;e[14]=fa+W+(Q>>>0<L>>>0?1:0)|0}};
	sjcl.mode.gcm={name:"gcm",encrypt:function(a,b,c,d,e){var f=b.slice(0);b=sjcl.bitArray;d=d||[];a=sjcl.mode.gcm.Z(!0,a,f,d,c,e||128);return b.concat(a.data,a.tag)},decrypt:function(a,b,c,d,e){var f=b.slice(0),g=sjcl.bitArray,h=g.bitLength(f);e=e||128;d=d||[];e<=h?(b=g.bitSlice(f,h-e),f=g.bitSlice(f,0,h-e)):(b=f,f=[]);a=sjcl.mode.gcm.Z(!1,a,f,d,c,e);if(!g.equal(a.tag,b))throw new sjcl.exception.corrupt("gcm: tag doesn't match");return a.data},la:function(a,b){var c,d,e,f,g,h=sjcl.bitArray.sa;e=[0,0,
	0,0];f=b.slice(0);for(c=0;128>c;c++){(d=0!==(a[Math.floor(c/32)]&1<<31-c%32))&&(e=h(e,f));g=0!==(f[3]&1);for(d=3;0<d;d--)f[d]=f[d]>>>1|(f[d-1]&1)<<31;f[0]>>>=1;g&&(f[0]^=-0x1f000000)}return e},w:function(a,b,c){var d,e=c.length;b=b.slice(0);for(d=0;d<e;d+=4)b[0]^=0xffffffff&c[d],b[1]^=0xffffffff&c[d+1],b[2]^=0xffffffff&c[d+2],b[3]^=0xffffffff&c[d+3],b=sjcl.mode.gcm.la(b,a);return b},Z:function(a,b,c,d,e,f){var g,h,k,l,n,m,p,q,r=sjcl.bitArray;m=c.length;p=r.bitLength(c);q=r.bitLength(d);h=r.bitLength(e);
	g=b.encrypt([0,0,0,0]);96===h?(e=e.slice(0),e=r.concat(e,[1])):(e=sjcl.mode.gcm.w(g,[0,0,0,0],e),e=sjcl.mode.gcm.w(g,e,[0,0,Math.floor(h/0x100000000),h&0xffffffff]));h=sjcl.mode.gcm.w(g,[0,0,0,0],d);n=e.slice(0);d=h.slice(0);a||(d=sjcl.mode.gcm.w(g,h,c));for(l=0;l<m;l+=4)n[3]++,k=b.encrypt(n),c[l]^=k[0],c[l+1]^=k[1],c[l+2]^=k[2],c[l+3]^=k[3];c=r.clamp(c,p);a&&(d=sjcl.mode.gcm.w(g,h,c));a=[Math.floor(q/0x100000000),q&0xffffffff,Math.floor(p/0x100000000),p&0xffffffff];d=sjcl.mode.gcm.w(g,d,a);k=b.encrypt(e);
	d[0]^=k[0];d[1]^=k[1];d[2]^=k[2];d[3]^=k[3];return{tag:r.bitSlice(d,0,f),data:c}}};sjcl.misc.hmac=function(a,b){this.$=b=b||sjcl.hash.sha256;var c=[[],[]],d,e=b.prototype.blockSize/32;this.H=[new b,new b];a.length>e&&(a=b.hash(a));for(d=0;d<e;d++)c[0][d]=a[d]^909522486,c[1][d]=a[d]^1549556828;this.H[0].update(c[0]);this.H[1].update(c[1]);this.V=new b(this.H[0])};
	sjcl.misc.hmac.prototype.encrypt=sjcl.misc.hmac.prototype.mac=function(a){if(this.ea)throw new sjcl.exception.invalid("encrypt on already updated hmac called!");this.update(a);return this.digest(a)};sjcl.misc.hmac.prototype.reset=function(){this.V=new this.$(this.H[0]);this.ea=!1};sjcl.misc.hmac.prototype.update=function(a){this.ea=!0;this.V.update(a)};sjcl.misc.hmac.prototype.digest=function(){var a=this.V.finalize(),a=(new this.$(this.H[1])).update(a).finalize();this.reset();return a};
	sjcl.misc.pbkdf2=function(a,b,c,d,e){c=c||1E3;if(0>d||0>c)throw sjcl.exception.invalid("invalid params to pbkdf2");"string"===typeof a&&(a=sjcl.codec.utf8String.toBits(a));"string"===typeof b&&(b=sjcl.codec.utf8String.toBits(b));e=e||sjcl.misc.hmac;a=new e(a);var f,g,h,k,l=[],n=sjcl.bitArray;for(k=1;32*l.length<(d||1);k++){e=f=a.encrypt(n.concat(b,[k]));for(g=1;g<c;g++)for(f=a.encrypt(f),h=0;h<f.length;h++)e[h]^=f[h];l=l.concat(e)}d&&(l=n.clamp(l,d));return l};sjcl.bn=function(a){this.initWith(a)};
	sjcl.bn.prototype={radix:24,maxMul:8,i:sjcl.bn,copy:function(){return new this.i(this)},initWith:function(a){var b=0,c;switch(typeof a){case "object":this.limbs=a.limbs.slice(0);break;case "number":this.limbs=[a];this.normalize();break;case "string":a=a.replace(/^0x/,"");this.limbs=[];c=this.radix/4;for(b=0;b<a.length;b+=c)this.limbs.push(parseInt(a.substring(Math.max(a.length-b-c,0),a.length-b),16));break;default:this.limbs=[0]}return this},equals:function(a){"number"===typeof a&&(a=new this.i(a));
	var b=0,c;this.fullReduce();a.fullReduce();for(c=0;c<this.limbs.length||c<a.limbs.length;c++)b|=this.getLimb(c)^a.getLimb(c);return 0===b},getLimb:function(a){return a>=this.limbs.length?0:this.limbs[a]},greaterEquals:function(a){"number"===typeof a&&(a=new this.i(a));var b=0,c=0,d,e,f;for(d=Math.max(this.limbs.length,a.limbs.length)-1;0<=d;d--)e=this.getLimb(d),f=a.getLimb(d),c|=f-e&~b,b|=e-f&~c;return(c|~b)>>>31},toString:function(){this.fullReduce();var a="",b,c,d=this.limbs;for(b=0;b<this.limbs.length;b++){for(c=
	d[b].toString(16);b<this.limbs.length-1&&6>c.length;)c="0"+c;a=c+a}return"0x"+a},addM:function(a){"object"!==typeof a&&(a=new this.i(a));var b=this.limbs,c=a.limbs;for(a=b.length;a<c.length;a++)b[a]=0;for(a=0;a<c.length;a++)b[a]+=c[a];return this},doubleM:function(){var a,b=0,c,d=this.radix,e=this.radixMask,f=this.limbs;for(a=0;a<f.length;a++)c=f[a],c=c+c+b,f[a]=c&e,b=c>>d;b&&f.push(b);return this},halveM:function(){var a,b=0,c,d=this.radix,e=this.limbs;for(a=e.length-1;0<=a;a--)c=e[a],e[a]=c+b>>
	1,b=(c&1)<<d;e[e.length-1]||e.pop();return this},subM:function(a){"object"!==typeof a&&(a=new this.i(a));var b=this.limbs,c=a.limbs;for(a=b.length;a<c.length;a++)b[a]=0;for(a=0;a<c.length;a++)b[a]-=c[a];return this},mod:function(a){var b=!this.greaterEquals(new sjcl.bn(0));a=(new sjcl.bn(a)).normalize();var c=(new sjcl.bn(this)).normalize(),d=0;for(b&&(c=(new sjcl.bn(0)).subM(c).normalize());c.greaterEquals(a);d++)a.doubleM();for(b&&(c=a.sub(c).normalize());0<d;d--)a.halveM(),c.greaterEquals(a)&&
	c.subM(a).normalize();return c.trim()},inverseMod:function(a){var b=new sjcl.bn(1),c=new sjcl.bn(0),d=new sjcl.bn(this),e=new sjcl.bn(a),f,g=1;if(!(a.limbs[0]&1))throw new sjcl.exception.invalid("inverseMod: p must be odd");do for(d.limbs[0]&1&&(d.greaterEquals(e)||(f=d,d=e,e=f,f=b,b=c,c=f),d.subM(e),d.normalize(),b.greaterEquals(c)||b.addM(a),b.subM(c)),d.halveM(),b.limbs[0]&1&&b.addM(a),b.normalize(),b.halveM(),f=g=0;f<d.limbs.length;f++)g|=d.limbs[f];while(g);if(!e.equals(1))throw new sjcl.exception.invalid("inverseMod: p and x must be relatively prime");
	return c},add:function(a){return this.copy().addM(a)},sub:function(a){return this.copy().subM(a)},mul:function(a){"number"===typeof a&&(a=new this.i(a));var b,c=this.limbs,d=a.limbs,e=c.length,f=d.length,g=new this.i,h=g.limbs,k,l=this.maxMul;for(b=0;b<this.limbs.length+a.limbs.length+1;b++)h[b]=0;for(b=0;b<e;b++){k=c[b];for(a=0;a<f;a++)h[b+a]+=k*d[a];--l||(l=this.maxMul,g.cnormalize())}return g.cnormalize().reduce()},square:function(){return this.mul(this)},power:function(a){a=(new sjcl.bn(a)).normalize().trim().limbs;
	var b,c,d=new this.i(1),e=this;for(b=0;b<a.length;b++)for(c=0;c<this.radix;c++){a[b]&1<<c&&(d=d.mul(e));if(b==a.length-1&&0==a[b]>>c+1)break;e=e.square()}return d},mulmod:function(a,b){return this.mod(b).mul(a.mod(b)).mod(b)},powermod:function(a,b){a=new sjcl.bn(a);b=new sjcl.bn(b);if(1==(b.limbs[0]&1)){var c=this.montpowermod(a,b);if(0!=c)return c}for(var d,e=a.normalize().trim().limbs,f=new this.i(1),g=this,c=0;c<e.length;c++)for(d=0;d<this.radix;d++){e[c]&1<<d&&(f=f.mulmod(g,b));if(c==e.length-
	1&&0==e[c]>>d+1)break;g=g.mulmod(g,b)}return f},montpowermod:function(a,b){function c(a,b){var c=b%a.radix;return(a.limbs[Math.floor(b/a.radix)]&1<<c)>>c}function d(a,c){var d,e,f=(1<<l+1)-1;d=a.mul(c);e=d.mul(q);e.limbs=e.limbs.slice(0,k.limbs.length);e.limbs.length==k.limbs.length&&(e.limbs[k.limbs.length-1]&=f);e=e.mul(b);e=d.add(e).normalize().trim();e.limbs=e.limbs.slice(k.limbs.length-1);for(d=0;d<e.limbs.length;d++)0<d&&(e.limbs[d-1]|=(e.limbs[d]&f)<<g-l-1),e.limbs[d]>>=l+1;e.greaterEquals(b)&&
	e.subM(b);return e}a=(new sjcl.bn(a)).normalize().trim();b=new sjcl.bn(b);var e,f,g=this.radix,h=new this.i(1);e=this.copy();var k,l,n;n=a.bitLength();k=new sjcl.bn({limbs:b.copy().normalize().trim().limbs.map(function(){return 0})});for(l=this.radix;0<l;l--)if(1==(b.limbs[b.limbs.length-1]>>l&1)){k.limbs[k.limbs.length-1]=1<<l;break}if(0==n)return this;n=18>n?1:48>n?3:144>n?4:768>n?5:6;var m=k.copy(),p=b.copy();f=new sjcl.bn(1);for(var q=new sjcl.bn(0),r=k.copy();r.greaterEquals(1);)r.halveM(),0==
	(f.limbs[0]&1)?(f.halveM(),q.halveM()):(f.addM(p),f.halveM(),q.halveM(),q.addM(m));f=f.normalize();q=q.normalize();m.doubleM();p=m.mulmod(m,b);if(!m.mul(f).sub(b.mul(q)).equals(1))return!1;e=d(e,p);h=d(h,p);m={};f=(1<<n-1)-1;m[1]=e.copy();m[2]=d(e,e);for(e=1;e<=f;e++)m[2*e+1]=d(m[2*e-1],m[2]);for(e=a.bitLength()-1;0<=e;)if(0==c(a,e))h=d(h,h),--e;else{for(p=e-n+1;0==c(a,p);)p++;r=0;for(f=p;f<=e;f++)r+=c(a,f)<<f-p,h=d(h,h);h=d(h,m[r]);e=p-1}return d(h,1)},trim:function(){var a=this.limbs,b;do b=a.pop();
	while(a.length&&0===b);a.push(b);return this},reduce:function(){return this},fullReduce:function(){return this.normalize()},normalize:function(){var a=0,b,c=this.placeVal,d=this.ipv,e,f=this.limbs,g=f.length,h=this.radixMask;for(b=0;b<g||0!==a&&-1!==a;b++)a=(f[b]||0)+a,e=f[b]=a&h,a=(a-e)*d;-1===a&&(f[b-1]-=c);this.trim();return this},cnormalize:function(){var a=0,b,c=this.ipv,d,e=this.limbs,f=e.length,g=this.radixMask;for(b=0;b<f-1;b++)a=e[b]+a,d=e[b]=a&g,a=(a-d)*c;e[b]+=a;return this},toBits:function(a){this.fullReduce();
	a=a||this.exponent||this.bitLength();var b=Math.floor((a-1)/24),c=sjcl.bitArray,d=[c.partial((a+7&-8)%this.radix||this.radix,this.getLimb(b))];for(b--;0<=b;b--)d=c.concat(d,[c.partial(Math.min(this.radix,a),this.getLimb(b))]),a-=this.radix;return d},bitLength:function(){this.fullReduce();for(var a=this.radix*(this.limbs.length-1),b=this.limbs[this.limbs.length-1];b;b>>>=1)a++;return a+7&-8}};
	sjcl.bn.fromBits=function(a){var b=new this,c=[],d=sjcl.bitArray,e=this.prototype,f=Math.min(this.bitLength||0x100000000,d.bitLength(a)),g=f%e.radix||e.radix;for(c[0]=d.extract(a,0,g);g<f;g+=e.radix)c.unshift(d.extract(a,g,e.radix));b.limbs=c;return b};sjcl.bn.prototype.ipv=1/(sjcl.bn.prototype.placeVal=Math.pow(2,sjcl.bn.prototype.radix));sjcl.bn.prototype.radixMask=(1<<sjcl.bn.prototype.radix)-1;
	sjcl.bn.pseudoMersennePrime=function(a,b){function c(a){this.initWith(a)}var d=c.prototype=new sjcl.bn,e,f;e=d.modOffset=Math.ceil(f=a/d.radix);d.exponent=a;d.offset=[];d.factor=[];d.minOffset=e;d.fullMask=0;d.fullOffset=[];d.fullFactor=[];d.modulus=c.modulus=new sjcl.bn(Math.pow(2,a));d.fullMask=0|-Math.pow(2,a%d.radix);for(e=0;e<b.length;e++)d.offset[e]=Math.floor(b[e][0]/d.radix-f),d.fullOffset[e]=Math.ceil(b[e][0]/d.radix-f),d.factor[e]=b[e][1]*Math.pow(.5,a-b[e][0]+d.offset[e]*d.radix),d.fullFactor[e]=
	b[e][1]*Math.pow(.5,a-b[e][0]+d.fullOffset[e]*d.radix),d.modulus.addM(new sjcl.bn(Math.pow(2,b[e][0])*b[e][1])),d.minOffset=Math.min(d.minOffset,-d.offset[e]);d.i=c;d.modulus.cnormalize();d.reduce=function(){var a,b,c,d=this.modOffset,e=this.limbs,f=this.offset,p=this.offset.length,q=this.factor,r;for(a=this.minOffset;e.length>d;){c=e.pop();r=e.length;for(b=0;b<p;b++)e[r+f[b]]-=q[b]*c;a--;a||(e.push(0),this.cnormalize(),a=this.minOffset)}this.cnormalize();return this};d.da=-1===d.fullMask?d.reduce:
	function(){var a=this.limbs,b=a.length-1,c,d;this.reduce();if(b===this.modOffset-1){d=a[b]&this.fullMask;a[b]-=d;for(c=0;c<this.fullOffset.length;c++)a[b+this.fullOffset[c]]-=this.fullFactor[c]*d;this.normalize()}};d.fullReduce=function(){var a,b;this.da();this.addM(this.modulus);this.addM(this.modulus);this.normalize();this.da();for(b=this.limbs.length;b<this.modOffset;b++)this.limbs[b]=0;a=this.greaterEquals(this.modulus);for(b=0;b<this.limbs.length;b++)this.limbs[b]-=this.modulus.limbs[b]*a;this.cnormalize();
	return this};d.inverse=function(){return this.power(this.modulus.sub(2))};c.fromBits=sjcl.bn.fromBits;return c};var A=sjcl.bn.pseudoMersennePrime;
	sjcl.bn.prime={p127:A(127,[[0,-1]]),p25519:A(255,[[0,-19]]),p192k:A(192,[[32,-1],[12,-1],[8,-1],[7,-1],[6,-1],[3,-1],[0,-1]]),p224k:A(224,[[32,-1],[12,-1],[11,-1],[9,-1],[7,-1],[4,-1],[1,-1],[0,-1]]),p256k:A(0x100,[[32,-1],[9,-1],[8,-1],[7,-1],[6,-1],[4,-1],[0,-1]]),p192:A(192,[[0,-1],[64,-1]]),p224:A(224,[[0,1],[96,-1]]),p256:A(0x100,[[0,-1],[96,1],[192,1],[224,-1]]),p384:A(384,[[0,-1],[32,1],[96,-1],[128,-1]]),p521:A(521,[[0,-1]])};
	sjcl.bn.random=function(a,b){"object"!==typeof a&&(a=new sjcl.bn(a));for(var c,d,e=a.limbs.length,f=a.limbs[e-1]+1,g=new sjcl.bn;;){do c=sjcl.random.randomWords(e,b),0>c[e-1]&&(c[e-1]+=0x100000000);while(Math.floor(c[e-1]/f)===Math.floor(0x100000000/f));c[e-1]%=f;for(d=0;d<e-1;d++)c[d]&=a.radixMask;g.limbs=c;if(!g.greaterEquals(a))return g}};sjcl.ecc={};
	sjcl.ecc.point=function(a,b,c){void 0===b?this.isIdentity=!0:(b instanceof sjcl.bn&&(b=new a.field(b)),c instanceof sjcl.bn&&(c=new a.field(c)),this.x=b,this.y=c,this.isIdentity=!1);this.curve=a};
	sjcl.ecc.point.prototype={toJac:function(){return new sjcl.ecc.pointJac(this.curve,this.x,this.y,new this.curve.field(1))},mult:function(a){return this.toJac().mult(a,this).toAffine()},mult2:function(a,b,c){return this.toJac().mult2(a,this,b,c).toAffine()},multiples:function(){var a,b,c;if(void 0===this.aa)for(c=this.toJac().doubl(),a=this.aa=[new sjcl.ecc.point(this.curve),this,c.toAffine()],b=3;16>b;b++)c=c.add(this),a.push(c.toAffine());return this.aa},negate:function(){var a=(new this.curve.field(0)).sub(this.y).normalize().reduce();
	return new sjcl.ecc.point(this.curve,this.x,a)},isValid:function(){return this.y.square().equals(this.curve.b.add(this.x.mul(this.curve.a.add(this.x.square()))))},toBits:function(){return sjcl.bitArray.concat(this.x.toBits(),this.y.toBits())}};sjcl.ecc.pointJac=function(a,b,c,d){void 0===b?this.isIdentity=!0:(this.x=b,this.y=c,this.z=d,this.isIdentity=!1);this.curve=a};
	sjcl.ecc.pointJac.prototype={add:function(a){var b,c,d,e;if(this.curve!==a.curve)throw"sjcl['ecc']['add'](): Points must be on the same curve to add them!";if(this.isIdentity)return a.toJac();if(a.isIdentity)return this;b=this.z.square();c=a.x.mul(b).subM(this.x);if(c.equals(0))return this.y.equals(a.y.mul(b.mul(this.z)))?this.doubl():new sjcl.ecc.pointJac(this.curve);b=a.y.mul(b.mul(this.z)).subM(this.y);d=c.square();a=b.square();e=c.square().mul(c).addM(this.x.add(this.x).mul(d));a=a.subM(e);b=
	this.x.mul(d).subM(a).mul(b);d=this.y.mul(c.square().mul(c));b=b.subM(d);c=this.z.mul(c);return new sjcl.ecc.pointJac(this.curve,a,b,c)},doubl:function(){if(this.isIdentity)return this;var a=this.y.square(),b=a.mul(this.x.mul(4)),c=a.square().mul(8),a=this.z.square(),d=this.curve.a.toString()==(new sjcl.bn(-3)).toString()?this.x.sub(a).mul(3).mul(this.x.add(a)):this.x.square().mul(3).add(a.square().mul(this.curve.a)),a=d.square().subM(b).subM(b),b=b.sub(a).mul(d).subM(c),c=this.y.add(this.y).mul(this.z);
	return new sjcl.ecc.pointJac(this.curve,a,b,c)},toAffine:function(){if(this.isIdentity||this.z.equals(0))return new sjcl.ecc.point(this.curve);var a=this.z.inverse(),b=a.square();return new sjcl.ecc.point(this.curve,this.x.mul(b).fullReduce(),this.y.mul(b.mul(a)).fullReduce())},mult:function(a,b){"number"===typeof a?a=[a]:void 0!==a.limbs&&(a=a.normalize().limbs);var c,d,e=(new sjcl.ecc.point(this.curve)).toJac(),f=b.multiples();for(c=a.length-1;0<=c;c--)for(d=sjcl.bn.prototype.radix-4;0<=d;d-=4)e=
	e.doubl().doubl().doubl().doubl().add(f[a[c]>>d&15]);return e},mult2:function(a,b,c,d){"number"===typeof a?a=[a]:void 0!==a.limbs&&(a=a.normalize().limbs);"number"===typeof c?c=[c]:void 0!==c.limbs&&(c=c.normalize().limbs);var e,f=(new sjcl.ecc.point(this.curve)).toJac();b=b.multiples();var g=d.multiples(),h,k;for(d=Math.max(a.length,c.length)-1;0<=d;d--)for(h=a[d]|0,k=c[d]|0,e=sjcl.bn.prototype.radix-4;0<=e;e-=4)f=f.doubl().doubl().doubl().doubl().add(b[h>>e&15]).add(g[k>>e&15]);return f},negate:function(){return this.toAffine().negate().toJac()},
	isValid:function(){var a=this.z.square(),b=a.square(),a=b.mul(a);return this.y.square().equals(this.curve.b.mul(a).add(this.x.mul(this.curve.a.mul(b).add(this.x.square()))))}};sjcl.ecc.curve=function(a,b,c,d,e,f){this.field=a;this.r=new sjcl.bn(b);this.a=new a(c);this.b=new a(d);this.G=new sjcl.ecc.point(this,new a(e),new a(f))};
	sjcl.ecc.curve.prototype.fromBits=function(a){var b=sjcl.bitArray,c=this.field.prototype.exponent+7&-8;a=new sjcl.ecc.point(this,this.field.fromBits(b.bitSlice(a,0,c)),this.field.fromBits(b.bitSlice(a,c,2*c)));if(!a.isValid())throw new sjcl.exception.corrupt("not on the curve!");return a};
	sjcl.ecc.curves={c192:new sjcl.ecc.curve(sjcl.bn.prime.p192,"0xffffffffffffffffffffffff99def836146bc9b1b4d22831",-3,"0x64210519e59c80e70fa7e9ab72243049feb8deecc146b9b1","0x188da80eb03090f67cbf20eb43a18800f4ff0afd82ff1012","0x07192b95ffc8da78631011ed6b24cdd573f977a11e794811"),c224:new sjcl.ecc.curve(sjcl.bn.prime.p224,"0xffffffffffffffffffffffffffff16a2e0b8f03e13dd29455c5c2a3d",-3,"0xb4050a850c04b3abf54132565044b0b7d7bfd8ba270b39432355ffb4","0xb70e0cbd6bb4bf7f321390b94a03c1d356c21122343280d6115c1d21",
	"0xbd376388b5f723fb4c22dfe6cd4375a05a07476444d5819985007e34"),c256:new sjcl.ecc.curve(sjcl.bn.prime.p256,"0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551",-3,"0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b","0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296","0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),c384:new sjcl.ecc.curve(sjcl.bn.prime.p384,"0xffffffffffffffffffffffffffffffffffffffffffffffffc7634d81f4372ddf581a0db248b0a77aecec196accc52973",
	-3,"0xb3312fa7e23ee7e4988e056be3f82d19181d9c6efe8141120314088f5013875ac656398d8a2ed19d2a85c8edd3ec2aef","0xaa87ca22be8b05378eb1c71ef320ad746e1d3b628ba79b9859f741e082542a385502f25dbf55296c3a545e3872760ab7","0x3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f"),c521:new sjcl.ecc.curve(sjcl.bn.prime.p521,"0x1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409",-3,"0x051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00",
	"0xC6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","0x11839296A789A3BC0045C8A5FB42C7D1BD998F54449579B446817AFBD17273E662C97EE72995EF42640C550B9013FAD0761353C7086A272C24088BE94769FD16650"),k192:new sjcl.ecc.curve(sjcl.bn.prime.p192k,"0xfffffffffffffffffffffffe26f2fc170f69466a74defd8d",0,3,"0xdb4ff10ec057e9ae26b07d0280b7f4341da5d1b1eae06c7d","0x9b2f2f6d9c5628a7844163d015be86344082aa88d95e2f9d"),k224:new sjcl.ecc.curve(sjcl.bn.prime.p224k,
	"0x010000000000000000000000000001dce8d2ec6184caf0a971769fb1f7",0,5,"0xa1455b334df099df30fc28a169a467e9e47075a90f7e650eb6b7a45c","0x7e089fed7fba344282cafbd6f7e319f7c0b0bd59e2ca4bdb556d61a5"),k256:new sjcl.ecc.curve(sjcl.bn.prime.p256k,"0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141",0,7,"0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")};
	sjcl.ecc.curveName=function(a){for(var b in sjcl.ecc.curves)if(sjcl.ecc.curves.hasOwnProperty(b)&&sjcl.ecc.curves[b]===a)return b;throw new sjcl.exception.invalid("no such curve");};
	sjcl.ecc.deserialize=function(a){if(!a||!a.curve||!sjcl.ecc.curves[a.curve])throw new sjcl.exception.invalid("invalid serialization");if(-1===["elGamal","ecdsa"].indexOf(a.type))throw new sjcl.exception.invalid("invalid type");var b=sjcl.ecc.curves[a.curve];if(a.secretKey){if(!a.exponent)throw new sjcl.exception.invalid("invalid exponent");var c=new sjcl.bn(a.exponent);return new sjcl.ecc[a.type].secretKey(b,c)}if(!a.point)throw new sjcl.exception.invalid("invalid point");c=b.fromBits(sjcl.codec.hex.toBits(a.point));
	return new sjcl.ecc[a.type].publicKey(b,c)};
	sjcl.ecc.basicKey={publicKey:function(a,b){this.m=a;this.v=a.r.bitLength();b instanceof Array?this.u=a.fromBits(b):this.u=b;this.serialize=function(){var b=sjcl.ecc.curveName(a);return{type:this.getType(),secretKey:!1,point:sjcl.codec.hex.fromBits(this.u.toBits()),curve:b}};this.get=function(){var a=this.u.toBits(),b=sjcl.bitArray.bitLength(a),e=sjcl.bitArray.bitSlice(a,0,b/2),a=sjcl.bitArray.bitSlice(a,b/2);return{x:e,y:a}}},secretKey:function(a,b){this.m=a;this.v=a.r.bitLength();this.J=b;this.serialize=
	function(){var b=this.get(),d=sjcl.ecc.curveName(a);return{type:this.getType(),secretKey:!0,exponent:sjcl.codec.hex.fromBits(b),curve:d}};this.get=function(){return this.J.toBits()}}};sjcl.ecc.basicKey.generateKeys=function(a){return function(b,c,d){b=b||0x100;if("number"===typeof b&&(b=sjcl.ecc.curves["c"+b],void 0===b))throw new sjcl.exception.invalid("no such curve");d=d||sjcl.bn.random(b.r,c);c=b.G.mult(d);return{pub:new sjcl.ecc[a].publicKey(b,c),sec:new sjcl.ecc[a].secretKey(b,d)}}};
	sjcl.ecc.elGamal={generateKeys:sjcl.ecc.basicKey.generateKeys("elGamal"),publicKey:function(a,b){sjcl.ecc.basicKey.publicKey.apply(this,arguments)},secretKey:function(a,b){sjcl.ecc.basicKey.secretKey.apply(this,arguments)}};sjcl.ecc.elGamal.publicKey.prototype={kem:function(a){a=sjcl.bn.random(this.m.r,a);var b=this.m.G.mult(a).toBits();return{key:sjcl.hash.sha256.hash(this.u.mult(a).toBits()),tag:b}},getType:function(){return"elGamal"}};
	sjcl.ecc.elGamal.secretKey.prototype={unkem:function(a){return sjcl.hash.sha256.hash(this.m.fromBits(a).mult(this.J).toBits())},dh:function(a){return sjcl.hash.sha256.hash(a.u.mult(this.J).toBits())},dhJavaEc:function(a){return a.u.mult(this.J).x.toBits()},getType:function(){return"elGamal"}};sjcl.ecc.ecdsa={generateKeys:sjcl.ecc.basicKey.generateKeys("ecdsa")};sjcl.ecc.ecdsa.publicKey=function(a,b){sjcl.ecc.basicKey.publicKey.apply(this,arguments)};
	sjcl.ecc.ecdsa.publicKey.prototype={verify:function(a,b,c){sjcl.bitArray.bitLength(a)>this.v&&(a=sjcl.bitArray.clamp(a,this.v));var d=sjcl.bitArray,e=this.m.r,f=this.v,g=sjcl.bn.fromBits(d.bitSlice(b,0,f)),d=sjcl.bn.fromBits(d.bitSlice(b,f,2*f)),h=c?d:d.inverseMod(e),f=sjcl.bn.fromBits(a).mul(h).mod(e),h=g.mul(h).mod(e),f=this.m.G.mult2(f,h,this.u).x;if(g.equals(0)||d.equals(0)||g.greaterEquals(e)||d.greaterEquals(e)||!f.equals(g)){if(void 0===c)return this.verify(a,b,!0);throw new sjcl.exception.corrupt("signature didn't check out");
	}return!0},getType:function(){return"ecdsa"}};sjcl.ecc.ecdsa.secretKey=function(a,b){sjcl.ecc.basicKey.secretKey.apply(this,arguments)};
	sjcl.ecc.ecdsa.secretKey.prototype={sign:function(a,b,c,d){sjcl.bitArray.bitLength(a)>this.v&&(a=sjcl.bitArray.clamp(a,this.v));var e=this.m.r,f=e.bitLength();d=d||sjcl.bn.random(e.sub(1),b).add(1);b=this.m.G.mult(d).x.mod(e);a=sjcl.bn.fromBits(a).add(b.mul(this.J));c=c?a.inverseMod(e).mul(d).mod(e):a.mul(d.inverseMod(e)).mod(e);return sjcl.bitArray.concat(b.toBits(f),c.toBits(f))},getType:function(){return"ecdsa"}};
	sjcl.prng=function(a){this.l=[new sjcl.hash.sha256];this.B=[0];this.U=0;this.M={};this.T=0;this.Y={};this.ba=this.o=this.C=this.ka=0;this.f=[0,0,0,0,0,0,0,0];this.s=[0,0,0,0];this.R=void 0;this.S=a;this.L=!1;this.P={progress:{},seeded:{}};this.F=this.ja=0;this.N=1;this.O=2;this.ga=0x10000;this.W=[0,48,64,96,128,192,0x100,384,512,768,1024];this.ha=3E4;this.fa=80};
	sjcl.prng.prototype={randomWords:function(a,b){var c=[],d;d=this.isReady(b);var e;if(d===this.F)throw new sjcl.exception.notReady("generator isn't seeded");if(d&this.O){d=!(d&this.N);e=[];var f=0,g;this.ba=e[0]=(new Date).valueOf()+this.ha;for(g=0;16>g;g++)e.push(0x100000000*Math.random()|0);for(g=0;g<this.l.length&&(e=e.concat(this.l[g].finalize()),f+=this.B[g],this.B[g]=0,d||!(this.U&1<<g));g++);this.U>=1<<this.l.length&&(this.l.push(new sjcl.hash.sha256),this.B.push(0));this.o-=f;f>this.C&&(this.C=
	f);this.U++;this.f=sjcl.hash.sha256.hash(this.f.concat(e));this.R=new sjcl.cipher.aes(this.f);for(d=0;4>d&&(this.s[d]=this.s[d]+1|0,!this.s[d]);d++);}for(d=0;d<a;d+=4)0===(d+1)%this.ga&&ba(this),e=N(this),c.push(e[0],e[1],e[2],e[3]);ba(this);return c.slice(0,a)},setDefaultParanoia:function(a,b){if(0===a&&"Setting paranoia=0 will ruin your security; use it only for testing"!==b)throw"Setting paranoia=0 will ruin your security; use it only for testing";this.S=a},addEntropy:function(a,b,c){c=c||"user";
	var d,e,f=(new Date).valueOf(),g=this.M[c],h=this.isReady(),k=0;d=this.Y[c];void 0===d&&(d=this.Y[c]=this.ka++);void 0===g&&(g=this.M[c]=0);this.M[c]=(this.M[c]+1)%this.l.length;switch(typeof a){case "number":void 0===b&&(b=1);this.l[g].update([d,this.T++,1,b,f,1,a|0]);break;case "object":c=Object.prototype.toString.call(a);if("[object Uint32Array]"===c){e=[];for(c=0;c<a.length;c++)e.push(a[c]);a=e}else for("[object Array]"!==c&&(k=1),c=0;c<a.length&&!k;c++)"number"!==typeof a[c]&&(k=1);if(!k){if(void 0===
	b)for(c=b=0;c<a.length;c++)for(e=a[c];0<e;)b++,e=e>>>1;this.l[g].update([d,this.T++,2,b,f,a.length].concat(a))}break;case "string":void 0===b&&(b=a.length);this.l[g].update([d,this.T++,3,b,f,a.length]);this.l[g].update(a);break;default:k=1}if(k)throw new sjcl.exception.bug("random: addEntropy only supports number, array of numbers or string");this.B[g]+=b;this.o+=b;h===this.F&&(this.isReady()!==this.F&&ca("seeded",Math.max(this.C,this.o)),ca("progress",this.getProgress()))},isReady:function(a){a=
	this.W[void 0!==a?a:this.S];return this.C&&this.C>=a?this.B[0]>this.fa&&(new Date).valueOf()>this.ba?this.O|this.N:this.N:this.o>=a?this.O|this.F:this.F},getProgress:function(a){a=this.W[a?a:this.S];return this.C>=a?1:this.o>a?1:this.o/a},startCollectors:function(){if(!this.L){this.c={loadTimeCollector:O(this,this.pa),mouseCollector:O(this,this.qa),keyboardCollector:O(this,this.na),accelerometerCollector:O(this,this.ia),touchCollector:O(this,this.ra)};if(window.addEventListener)window.addEventListener("load",
	this.c.loadTimeCollector,!1),window.addEventListener("mousemove",this.c.mouseCollector,!1),window.addEventListener("keypress",this.c.keyboardCollector,!1),window.addEventListener("devicemotion",this.c.accelerometerCollector,!1),window.addEventListener("touchmove",this.c.touchCollector,!1);else if(document.attachEvent)document.attachEvent("onload",this.c.loadTimeCollector),document.attachEvent("onmousemove",this.c.mouseCollector),document.attachEvent("keypress",this.c.keyboardCollector);else throw new sjcl.exception.bug("can't attach event");
	this.L=!0}},stopCollectors:function(){this.L&&(window.removeEventListener?(window.removeEventListener("load",this.c.loadTimeCollector,!1),window.removeEventListener("mousemove",this.c.mouseCollector,!1),window.removeEventListener("keypress",this.c.keyboardCollector,!1),window.removeEventListener("devicemotion",this.c.accelerometerCollector,!1),window.removeEventListener("touchmove",this.c.touchCollector,!1)):document.detachEvent&&(document.detachEvent("onload",this.c.loadTimeCollector),document.detachEvent("onmousemove",
	this.c.mouseCollector),document.detachEvent("keypress",this.c.keyboardCollector)),this.L=!1)},addEventListener:function(a,b){this.P[a][this.ja++]=b},removeEventListener:function(a,b){var c,d,e=this.P[a],f=[];for(d in e)e.hasOwnProperty(d)&&e[d]===b&&f.push(d);for(c=0;c<f.length;c++)d=f[c],delete e[d]},na:function(){T(this,1)},qa:function(a){var b,c;try{b=a.x||a.clientX||a.offsetX||0,c=a.y||a.clientY||a.offsetY||0}catch(d){c=b=0}0!=b&&0!=c&&this.addEntropy([b,c],2,"mouse");T(this,0)},ra:function(a){a=
	a.touches[0]||a.changedTouches[0];this.addEntropy([a.pageX||a.clientX,a.pageY||a.clientY],1,"touch");T(this,0)},pa:function(){T(this,2)},ia:function(a){a=a.accelerationIncludingGravity.x||a.accelerationIncludingGravity.y||a.accelerationIncludingGravity.z;if(window.orientation){var b=window.orientation;"number"===typeof b&&this.addEntropy(b,1,"accelerometer")}a&&this.addEntropy(a,2,"accelerometer");T(this,0)}};
	function ca(a,b){var c,d=sjcl.random.P[a],e=[];for(c in d)d.hasOwnProperty(c)&&e.push(d[c]);for(c=0;c<e.length;c++)e[c](b)}function T(a,b){"undefined"!==typeof window&&window.performance&&"function"===typeof window.performance.now?a.addEntropy(window.performance.now(),b,"loadtime"):a.addEntropy((new Date).valueOf(),b,"loadtime")}function ba(a){a.f=N(a).concat(N(a));a.R=new sjcl.cipher.aes(a.f)}function N(a){for(var b=0;4>b&&(a.s[b]=a.s[b]+1|0,!a.s[b]);b++);return a.R.encrypt(a.s)}
	function O(a,b){return function(){b.apply(a,arguments)}}sjcl.random=new sjcl.prng(6);
	a:try{var U,da,Z,ia;if(ia="undefined"!==typeof module&&module.exports){var ja;try{ja=__webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))}catch(a){ja=null}ia=da=ja}if(ia&&da.randomBytes)U=da.randomBytes(128),U=new Uint32Array((new Uint8Array(U)).buffer),sjcl.random.addEntropy(U,1024,"crypto['randomBytes']");else if("undefined"!==typeof window&&"undefined"!==typeof Uint32Array){Z=new Uint32Array(32);if(window.crypto&&window.crypto.getRandomValues)window.crypto.getRandomValues(Z);else if(window.msCrypto&&window.msCrypto.getRandomValues)window.msCrypto.getRandomValues(Z);
	else break a;sjcl.random.addEntropy(Z,1024,"crypto['getRandomValues']")}}catch(a){"undefined"!==typeof window&&window.console&&(console.log("There was an error collecting entropy from the browser:"),console.log(a))}
	sjcl.misc.hkdf=function(a,b,c,d,e){var f,g=[];e=e||sjcl.hash.sha256;"string"===typeof d&&(d=sjcl.codec.utf8String.toBits(d));"string"===typeof c?c=sjcl.codec.utf8String.toBits(c):c||(c=[]);c=new sjcl.misc.hmac(c,e);c=c.mac(a);a=sjcl.bitArray.bitLength(c);a=Math.ceil(b/a);if(255<a)throw new sjcl.exception.invalid("key bit length is too large for hkdf");c=new sjcl.misc.hmac(c,e);f=[];for(e=1;e<=a;e++)c.update(f),c.update(d),c.update([sjcl.bitArray.partial(8,e)]),f=c.digest(),g=sjcl.bitArray.concat(g,
	f);return sjcl.bitArray.clamp(g,b)};
	


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(19);
	var _map = __webpack_require__(29);
	var _reduce = __webpack_require__(30);
	var _xmap = __webpack_require__(91);
	var curryN = __webpack_require__(9);
	var keys = __webpack_require__(22);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 */
	module.exports = _curry2(_dispatchable('map', _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createRandom = createRandom;
	exports.createKey = createKey;
	exports.createIV = createIV;
	exports.createSalt = createSalt;
	
	var _sjcl = __webpack_require__(11);
	
	var _sjcl2 = _interopRequireDefault(_sjcl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create random string
	 *
	 * @param {Number} bits number of bits [64, 128, 256]
	 * @return {Base64UrlString}
	 * @throws {Error} if a generator isn't seeded
	 * @public
	 */
	function createRandom(bits) {
	  return _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.random.randomWords(bits / 32));
	}
	
	/**
	 * Create encryption key of size 256 bits
	 *
	 * @return {Base64UrlString}
	 * @throws {Error} if a generator isn't seeded
	 * @public
	 */
	function createKey() {
	  return createRandom(256);
	}
	
	/**
	 * Create initialization vector of size 128 bits
	 *
	 * @return {Base64UrlString}
	 * @throws {Error} if a generator isn't seeded
	 * @public
	 */
	function createIV() {
	  return createRandom(128);
	}
	
	/**
	 * Create salt of size 64 bits
	 *
	 * @return {Base64UrlString}
	 * @throws {Error} if a generator isn't seeded
	 * @private
	 */
	function createSalt() {
	  return createRandom(64);
	}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn
	 * @param {Array} args
	 * @return {*}
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _map = __webpack_require__(29);
	var curryN = __webpack_require__(9);
	var max = __webpack_require__(98);
	var pluck = __webpack_require__(105);
	var reduce = __webpack_require__(43);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @example
	 *
	 *      var add = (a, b) => a + b;
	 *      var multiply = (a, b) => a * b;
	 *      var subtract = (a, b) => a - b;
	 *
	 *      //≅ multiply( add(1, 2), subtract(1, 2) );
	 *      R.converge(multiply, [add, subtract])(1, 2); //=> -3
	 *
	 *      var add3 = (a, b, c) => a + b + c;
	 *      R.converge(add3, [multiply, add, subtract])(1, 2); //=> 4
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(28);
	var _isTransformer = __webpack_require__(80);
	var _slice = __webpack_require__(3);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with [methodname], it will execute that
	 * function (functor case). Otherwise, if it is a transformer, uses transducer
	 * [xf] to return a new transformer (transducer case). Otherwise, it will
	 * default to executing [fn].
	 *
	 * @private
	 * @param {String} methodname property to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodname, xf, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    if (!_isArray(obj)) {
	      var args = _slice(arguments, 0, length - 1);
	      if (typeof obj[methodname] === 'function') {
	        return obj[methodname].apply(obj, args);
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _has = __webpack_require__(20);
	var _isArguments = __webpack_require__(78);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deriveKey = deriveKey;
	
	var _sjcl = __webpack_require__(11);
	
	var _sjcl2 = _interopRequireDefault(_sjcl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Derives encryption key from simple text
	 *
	 * @param {String} password
	 * @param {Object} $1 derivation params
	 * @param {Base64UrlString} $1.salt
	 * @param {Number} $1.iterations
	 * @return {Base64UrlString}
	 * @throws {Error} if a parameter is invalid
	 * @public
	 */
	function deriveKey(password, _ref) {
	  var salt = _ref.salt,
	      iterations = _ref.iterations;
	
	  return _sjcl2.default.codec.base64url.fromBits(_sjcl2.default.misc.pbkdf2(password, _sjcl2.default.codec.base64url.toBits(salt), iterations));
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.decrypt = undefined;
	
	var _apply = __webpack_require__(17);
	
	var _apply2 = _interopRequireDefault(_apply);
	
	var _ = __webpack_require__(16);
	
	var _2 = _interopRequireDefault(_);
	
	var _curry = __webpack_require__(5);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _compose = __webpack_require__(8);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _objOf = __webpack_require__(32);
	
	var _objOf2 = _interopRequireDefault(_objOf);
	
	var _merge = __webpack_require__(41);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _useWith = __webpack_require__(34);
	
	var _useWith2 = _interopRequireDefault(_useWith);
	
	var _insert = __webpack_require__(68);
	
	var _insert2 = _interopRequireDefault(_insert);
	
	var _unapply = __webpack_require__(45);
	
	var _unapply2 = _interopRequireDefault(_unapply);
	
	var _map = __webpack_require__(13);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _prop = __webpack_require__(14);
	
	var _prop2 = _interopRequireDefault(_prop);
	
	var _converge = __webpack_require__(18);
	
	var _converge2 = _interopRequireDefault(_converge);
	
	exports._createFile = _createFile;
	exports._argumentsForMultipleFileEncryptions = _argumentsForMultipleFileEncryptions;
	exports._createData = _createData;
	exports.encrypt = encrypt;
	
	var _aes = __webpack_require__(7);
	
	var _file = __webpack_require__(25);
	
	var _format = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create file info
	 *
	 * @param {{name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer, encryptionParams: SymmetricEncryptionParams}} file
	 * @return {FileMetadata}
	 * @private
	 */
	function _createFile(file) {
	  return (0, _converge2.default)(_format.createFileMetadata, [(0, _prop2.default)('name'), (0, _prop2.default)('size'), (0, _prop2.default)('type'), (0, _prop2.default)('id')])(file);
	}
	
	/**
	 * Prepare arguments for multiple file encryptions
	 *
	 * @param {Base64UrlString} encryptionKey
	 * @param {{name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer, encryptionParams: SymmetricEncryptionParams}[]} files
	 * @return {Array.<Array.<String, String, String, ArrayBuffer, Base64UrlString, SymmetricEncryptionParams>>} 2d array of arguments compatible with encryptFile
	 * @private
	 */
	function _argumentsForMultipleFileEncryptions(encryptionKey, files) {
	  return (0, _map2.default)((0, _converge2.default)((0, _unapply2.default)((0, _insert2.default)(4, encryptionKey)), [(0, _prop2.default)('id'), (0, _prop2.default)('path'), (0, _prop2.default)('service'), (0, _prop2.default)('data'), (0, _prop2.default)('encryptionParams')]))(files);
	}
	
	/**
	 * Create data
	 *
	 * @param {String} text
	 * @param {{name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer, encryptionParams: SymmetricEncryptionParams}[]} files
	 * @return {Data}
	 * @private
	 */
	function _createData(text, files) {
	  return (0, _format.createData)(text, (0, _map2.default)(_createFile, files));
	}
	
	/**
	 * Encrypt data
	 *
	 * @param {Base64UrlString} encryptionKey
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @param {String} text
	 * @param {{name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer, encryptionParams: SymmetricEncryptionParams}[]} files
	 * @return {{data: Base64UrlString, files: Object.<String, ArrayBuffer>}} encrypted data
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encrypt(encryptionKey, encryptionParams, text, files) {
	  return (0, _useWith2.default)((0, _useWith2.default)(_merge2.default, [(0, _objOf2.default)('data'), (0, _objOf2.default)('files')]), [(0, _compose2.default)((0, _curry2.default)(_aes.encryptObject)(_2.default, encryptionKey, encryptionParams), (0, _apply2.default)(_createData)), (0, _compose2.default)((0, _map2.default)((0, _apply2.default)(_file.encrypt)), (0, _apply2.default)(_argumentsForMultipleFileEncryptions))])([text, files], [encryptionKey, files]);
	}
	
	/**
	 * Decrypt data
	 *
	 * @name decryptData
	 * @param {Base64UrlString} data
	 * @param {Base64UrlString} decryptionKey
	 * @param {SymmetricEncryptionParams} decryptionParams
	 * @return {Data} decrypted data
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., keys.public, ..., [{ password, hint }], ...)
	 *  const header = CryptolizeCore.decryptRecord(record, keys.private)[0]
	 *  const key = CryptolizeCore.decryptKeyWithSymmetricEncryption(password, header)
	 *  const data = CryptolizeCore.decryptData(record.blocks[0].data, key, header.dataEncryptionParams)
	 *  console.log(data)
	 */
	var decrypt = exports.decrypt = _aes.decryptObject;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.decrypt = undefined;
	exports.encrypt = encrypt;
	
	var _aes = __webpack_require__(7);
	
	var _format = __webpack_require__(4);
	
	/**
	 * Encrypt file
	 *
	 * @param {String} id
	 * @param {String} path
	 * @param {String} service
	 * @param {ArrayBuffer} data
	 * @param {Base64UrlString} encryptionKey
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @return {EncryptedFile}
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encrypt(id, path, service, data, encryptionKey, encryptionParams) {
	  return (0, _format.createEncryptedFile)(id, path, service, (0, _aes.encryptFile)(data, encryptionKey, encryptionParams));
	}
	
	/**
	 * Decrypt file
	 *
	 * @name decryptFile
	 * @param {ArrayBuffer} data
	 * @param {Base64UrlString} decryptionKey
	 * @param {SymmetricEncryptionParams} decryptionParams
	 * @return {ArrayBuffer}
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @public
	  * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., keys.public, ..., [{ password, hint }], ...)
	 *  const header = CryptolizeCore.decryptRecord(record, keys.private)[0]
	 *  const key = CryptolizeCore.decryptKeyWithSymmetricEncryption(password, header)
	 *  const file = CryptolizeCore.decryptFile(record.blocks[0].files[0].data, key, header.filesEncryptionParams[0].encryptionParams)
	 *  console.log(file)
	*/
	var decrypt = exports.decrypt = _aes.decryptFile;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _not = __webpack_require__(101);
	
	var _not2 = _interopRequireDefault(_not);
	
	var _propEq = __webpack_require__(107);
	
	var _propEq2 = _interopRequireDefault(_propEq);
	
	var _and = __webpack_require__(54);
	
	var _and2 = _interopRequireDefault(_and);
	
	var _converge = __webpack_require__(18);
	
	var _converge2 = _interopRequireDefault(_converge);
	
	var _find = __webpack_require__(63);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _head = __webpack_require__(65);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _tail = __webpack_require__(44);
	
	var _tail2 = _interopRequireDefault(_tail);
	
	var _curry = __webpack_require__(5);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _tryCatch = __webpack_require__(113);
	
	var _tryCatch2 = _interopRequireDefault(_tryCatch);
	
	var _isNil = __webpack_require__(96);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _ifElse = __webpack_require__(67);
	
	var _ifElse2 = _interopRequireDefault(_ifElse);
	
	var _identity = __webpack_require__(36);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _useWith = __webpack_require__(34);
	
	var _useWith2 = _interopRequireDefault(_useWith);
	
	var _apply = __webpack_require__(17);
	
	var _apply2 = _interopRequireDefault(_apply);
	
	var _props = __webpack_require__(33);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _prepend = __webpack_require__(106);
	
	var _prepend2 = _interopRequireDefault(_prepend);
	
	var _compose = __webpack_require__(8);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _map = __webpack_require__(13);
	
	var _map2 = _interopRequireDefault(_map);
	
	exports._argumentsForMultipleSymmetricKeyEncryptions = _argumentsForMultipleSymmetricKeyEncryptions;
	exports._argumentsForMultipleAsymmetricKeyEncryptions = _argumentsForMultipleAsymmetricKeyEncryptions;
	exports._multipleFilesEncryptionParams = _multipleFilesEncryptionParams;
	exports._multipleFilesStorageParams = _multipleFilesStorageParams;
	exports.encryptKey = encryptKey;
	exports.decryptKeyWithSymmetricEncryption = decryptKeyWithSymmetricEncryption;
	exports.decryptKeyWithAsymmetricEncryption = decryptKeyWithAsymmetricEncryption;
	exports.hasSymmetricEncryption = hasSymmetricEncryption;
	exports.hasAsymmetricEncryption = hasAsymmetricEncryption;
	exports.getAsymmetricEncryptionParams = getAsymmetricEncryptionParams;
	
	var _key = __webpack_require__(51);
	
	var _format = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Prepare arguments for multiple symmetric encryptions
	 *
	 * @param {Base64UrlString} encryptionKey
	 * @param {{derivationParams: DerivationParams, encryptionParams: SymmetricEncryptionParams, password: String, hint: String}[]} symmetricEncryptionParams
	 * @return {Array.<Array.<Base64UrlString, DerivationParams, SymmetricEncryptionParams, String, String>>} 2d array of arguments compatible with encryptKeyWithSymmetricEncryption
	 * @private
	 */
	function _argumentsForMultipleSymmetricKeyEncryptions(encryptionKey, symmetricEncryptionParams) {
	  return (0, _map2.default)((0, _compose2.default)((0, _prepend2.default)(encryptionKey), (0, _props2.default)(['derivationParams', 'encryptionParams', 'password', 'hint'])))(symmetricEncryptionParams);
	}
	
	/**
	 * Prepare arguments for multiple asymmetric encryptions
	 *
	 * @param {Base64UrlString} encryptionKey
	 * @param {{tag: Base64UrlString, key: Base64UrlString, encryptionParams: SymmetricEncryptionParams, id: String, version: String}[]} asymmetricEncryptionParams
	 * @return {Array.<Array.<Base64UrlString, Base64UrlString, SymmetricEncryptionParams, Base64UrlString, String, String>>} 2d array of arguments compatible with encryptKeyWithAsymmetricEncryption
	 * @private
	 */
	function _argumentsForMultipleAsymmetricKeyEncryptions(encryptionKey, asymmetricEncryptionParams) {
	  return (0, _map2.default)((0, _compose2.default)((0, _prepend2.default)(encryptionKey), (0, _props2.default)(['tag', 'encryptionParams', 'key', 'id', 'version'])))(asymmetricEncryptionParams);
	}
	
	/**
	 * Prepare arguments for multiple asymmetric encryptions
	 *
	 * @param {{name: String, size: Number, type: String, data: ArrayBuffer, id: String, path: String, service: String, encryptionParams: SymmetricEncryptionParams}[]} files
	 * @return {FilesEncryptionParams[]}
	 * @private
	 */
	function _multipleFilesEncryptionParams(files) {
	  return (0, _map2.default)((0, _compose2.default)((0, _apply2.default)(_format.createFilesEncryptionParams), (0, _props2.default)(['id', 'encryptionParams'])))(files);
	}
	
	/**
	 * Prepare arguments for multiple files storage
	 *
	 * @param {{name: String, size: Number, type: String, data: ArrayBuffer, id: String, path: String, service: String, encryptionParams: SymmetricEncryptionParams}[]} files
	 * @return {FilesStorageParams[]}
	 * @private
	 */
	function _multipleFilesStorageParams(files) {
	  return (0, _map2.default)((0, _compose2.default)((0, _apply2.default)(_format.createFilesStorageParams), (0, _props2.default)(['id', 'path', 'service'])))(files);
	}
	
	/**
	 * Encrypt key with both symmetric encryption and asymmetric encryption
	 *
	 * @param {Base64UrlString} encryptionKey
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @param {{name: String, size: Number, type: String, data: ArrayBuffer, id: String, path: String, service: String, encryptionParams: SymmetricEncryptionParams}[]} files
	 * @param {{derivationParams: DerivationParams, encryptionParams: SymmetricEncryptionParams, password: String, hint: String}[]} symmetricEncryptionParams
	 * @param {{tag: Base64UrlString, key: Base64UrlString, encryptionParams: SymmetricEncryptionParams, id: String, version: String}[]} asymmetricEncryptionParams
	 * @return {Header}
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encryptKey(encryptionKey, encryptionParams, files, symmetricEncryptionParams, asymmetricEncryptionParams) {
	  return (0, _useWith2.default)(_format.createHeader, [(0, _compose2.default)((0, _map2.default)((0, _apply2.default)(_key.encryptWithSymmetricEncryption)), (0, _apply2.default)(_argumentsForMultipleSymmetricKeyEncryptions)), (0, _compose2.default)((0, _map2.default)((0, _apply2.default)(_key.encryptWithAsymmetricEncryption)), (0, _apply2.default)(_argumentsForMultipleAsymmetricKeyEncryptions)), _identity2.default, _multipleFilesEncryptionParams, _multipleFilesStorageParams])([encryptionKey, symmetricEncryptionParams], [encryptionKey, asymmetricEncryptionParams], encryptionParams, files, files);
	}
	
	/**
	 * Decrypt key with symmetric encryption
	 *
	 * @param {String} password
	 * @param {Header} header
	 * @return {Base64UrlString} encrypted key
	 * @throws {Error} if the symmetricEncryption array is empty, data is corrupt or wrong password
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., keys.public, ..., [{ password, hint }], ...)
	 *  const headers = CryptolizeCore.decryptRecord(record, keys.private)
	 *  const key = CryptolizeCore.decryptKeyWithSymmetricEncryption(password, header[0])
	 *  console.log(key)
	 */
	function decryptKeyWithSymmetricEncryption(password, _ref) {
	  var symmetricEncryption = _ref.symmetricEncryption;
	
	  return (0, _ifElse2.default)(_isNil2.default, function () {
	    throw new Error('symmetricEncryption array is empty or wrong password');
	  }, (0, _tryCatch2.default)((0, _curry2.default)(_key.decryptWithSymmetricEncryption)(password), function () {
	    return decryptKeyWithSymmetricEncryption(password, { symmetricEncryption: (0, _tail2.default)(symmetricEncryption) });
	  }))((0, _head2.default)(symmetricEncryption));
	}
	
	/**
	 * Decrypt key with asymmetric encryption
	 *
	 * @param {String} id
	 * @param {String} version
	 * @param {ElGamalPrivateKey} privateKey
	 * @param {Header} header
	 * @return {Base64UrlString} encrypted key
	 * @throws {Error} if the asymmetricEncryption array is empty, data is corrupt or wrong keyId
	 * @public
	 * @example
	 *  const headerKeys = CryptolizeCore.createAsymmetricKeys()
	 *  const id = 'id'
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., headerKeys.public, ..., [{ id: id, version: keys.public, key: keys.public }], ...)
	 *  const headers = CryptolizeCore.decryptRecord(record, headerKeys.private)
	 *  const key = CryptolizeCore.decryptKeyWithAsymmetricEncryption(id, keys.public, keys.private, header[0])
	 *  console.log(key)
	 */
	function decryptKeyWithAsymmetricEncryption(id, version, privateKey, _ref2) {
	  var asymmetricEncryption = _ref2.asymmetricEncryption;
	
	  return (0, _compose2.default)((0, _ifElse2.default)(_isNil2.default, function () {
	    throw new Error('asymmetricEncryption array is empty or wrong keyId');
	  }, (0, _curry2.default)(_key.decryptWithAsymmetricEncryption)(privateKey)), (0, _find2.default)((0, _converge2.default)(_and2.default, [(0, _propEq2.default)('id', id), (0, _propEq2.default)('version', version)])))(asymmetricEncryption);
	}
	
	/**
	 * returns true if symmetric encryption exists, false otherwise
	 *
	 * @param {Header} header
	 * @return {Boolean}
	 * @public
	 * @example
	 *  const headerKeys = CryptolizeCore.createAsymmetricKeys()
	 *  const id = 'id'
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., headerKeys.public, ..., [{ id: id, version: keys.public, key: keys.public }], ...)
	 *  const headers = CryptolizeCore.decryptRecord(record, headerKeys.private)
	 *  const hasSymmetricEncryption = CryptolizeCore.hasSymmetricEncryption(header[0])
	 *  console.log(hasSymmetricEncryption)
	 */
	function hasSymmetricEncryption(_ref3) {
	  var symmetricEncryption = _ref3.symmetricEncryption;
	
	  return symmetricEncryption.length > 0;
	}
	
	/**
	 * returns true if asymmetric encryption with supplied id exists, false otherwise
	 *
	 * @param {String} id
	 * @param {Header} header
	 * @return {Boolean}
	 * @public
	 * @example
	 *  const headerKeys = CryptolizeCore.createAsymmetricKeys()
	 *  const id = 'id'
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., headerKeys.public, ..., [{ id: id, version: keys.public, key: keys.public }], ...)
	 *  const headers = CryptolizeCore.decryptRecord(record, headerKeys.private)
	 *  const hasAsymmetricEncryption = CryptolizeCore.hasAsymmetricEncryption(id, header[0])
	 *  console.log(hasAsymmetricEncryption)
	 */
	function hasAsymmetricEncryption(id, header) {
	  return (0, _not2.default)((0, _isNil2.default)(getAsymmetricEncryptionParams(id, header)));
	}
	
	/**
	 * returns asymmetric encryption params of the supplied id
	 *
	 * @param {String} id
	 * @param {Header} header
	 * @return {(AsymmetricEncryptionWrapper|undefined)}
	 * @public
	 * @example
	 *  const headerKeys = CryptolizeCore.createAsymmetricKeys()
	 *  const id = 'id'
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const password = 'password'
	 *  const hint = 'hint'
	 *  const record = CryptolizeCore.encryptRecord(..., headerKeys.public, ..., [{ id: id, version: keys.public, key: keys.public }], ...)
	 *  const headers = CryptolizeCore.decryptRecord(record, headerKeys.private)
	 *  const asymmetricEncryptionParams = CryptolizeCore.getAsymmetricEncryptionParams(id, header[0])
	 *  console.log(asymmetricEncryptionParams)
	 */
	function getAsymmetricEncryptionParams(id, _ref4) {
	  var asymmetricEncryption = _ref4.asymmetricEncryption;
	
	  return (0, _find2.default)((0, _propEq2.default)('id', id), asymmetricEncryption);
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _equals = __webpack_require__(73);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(92);
	var bind = __webpack_require__(55);
	var isArrayLike = __webpack_require__(95);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _slice = __webpack_require__(3);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(_slice(arguments, transformers.length)));
	  });
	});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _props = __webpack_require__(33);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _apply = __webpack_require__(17);
	
	var _apply2 = _interopRequireDefault(_apply);
	
	var _dissoc = __webpack_require__(58);
	
	var _dissoc2 = _interopRequireDefault(_dissoc);
	
	var _prop = __webpack_require__(14);
	
	var _prop2 = _interopRequireDefault(_prop);
	
	var _map = __webpack_require__(13);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _objOf = __webpack_require__(32);
	
	var _objOf2 = _interopRequireDefault(_objOf);
	
	var _merge = __webpack_require__(41);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _ = __webpack_require__(16);
	
	var _2 = _interopRequireDefault(_);
	
	var _curry = __webpack_require__(5);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _converge = __webpack_require__(18);
	
	var _converge2 = _interopRequireDefault(_converge);
	
	var _compose = __webpack_require__(8);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	exports.encrypt = encrypt;
	exports.decrypt = decrypt;
	
	var _random = __webpack_require__(15);
	
	var _aes = __webpack_require__(7);
	
	var _ecc = __webpack_require__(10);
	
	var _block = __webpack_require__(50);
	
	var _format = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Encrypt record
	 *
	 * @name encryptRecord
	 * @param {ElGamalPublicKey} headerKey public key for header encryption
	 * @param {RecordMetadata} metadata
	 * @param {{text: String, files: {name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer}[], passwords: {password: String, hint: String, iterations: Number}[], publicKeys: {id: String, version: String, key: ElGamalPublicKey}[]}} blocks
	 * @return {Record} the encrypted record
	 * @throws {Error} if a parameter is invalid
	 * @public
	 * @example
	 *  const headerKey = CryptolizeCore.createAsymmetricKeys().public
	 *
	 *  const metadata = CryptolizeCore.createRecordMetadata(
	 *    'id',
	 *    'creator',
	 *    'personalPage',
	 *    'signature',
	 *    'signatureKeyVersion',
	 *    new Date().getTime(),
	 *    new Date().getTimezoneOffset(),
	 *    false,
	 *    new Date().getTime(),
	 *    'subject',
	 *    'origin',
	 *    {
	 *      key1: 'value1',
	 *      key2: 'value2'
	 *    }
	 *  )
	 *
	 *  const password = { password: 'password', hint: 'hint', iterations: 100000 }
	 *  const publicKey = { id: 'publicKeyOwnerId', version: CryptolizeCore.createAsymmetricKeys().public, key: CryptolizeCore.createAsymmetricKeys().public }
	 *  const text = 'text'
	 *  const file = {
	 *    name: 'name',
	 *    size: 1024,
	 *    type: 'type',
	 *    id: 'id',
	 *    path: 'path',
	 *    service: 'service',
	 *    data: 'ArrayBuffer'
	 *  }
	 *  const block = { passwords: [password], publicKeys: [publicKey], text: 'text', files: [file] }
	 *
	 *  const record = CryptolizeCore.encryptRecord(headerKey, metadata, [block])
	 *  console.log(record)
	 */
	function encrypt(headerKey, metadata, blocks) {
	  var _createSymmetricEncry = (0, _ecc.createSymmetricEncryptionKeyFromPublicKey)(headerKey),
	      headerEncryptionKey = _createSymmetricEncry.key,
	      tag = _createSymmetricEncry.tag;
	
	  var headerEncryptionParams = (0, _format.createEncryptionParams)((0, _random.createIV)());
	  var headerWrapperEncryptionParams = (0, _format.createHeaderWrapperEncryptionParams)(headerKey, tag, headerEncryptionParams);
	  return (0, _compose2.default)((0, _converge2.default)((0, _curry2.default)(_format.createRecord)(_2.default, headerWrapperEncryptionParams, _2.default), [(0, _compose2.default)((0, _curry2.default)(_aes.encryptObject)(_2.default, headerEncryptionKey, headerEncryptionParams), (0, _merge2.default)({ metadata: metadata }), (0, _objOf2.default)('blocks'), (0, _map2.default)((0, _prop2.default)('header'))), (0, _map2.default)((0, _dissoc2.default)('header'))]), (0, _map2.default)((0, _apply2.default)((0, _curry2.default)(_block.encrypt)(_2.default, _2.default, _2.default, _2.default))), (0, _map2.default)((0, _props2.default)(['passwords', 'publicKeys', 'text', 'files'])))(blocks);
	}
	
	/**
	 * Decrypt record
	 *
	 * @name decryptRecord
	 * @param {Record} record
	 * @param {ElGamalPrivateKey} headerKey
	 * @return {HeaderWrapper} header wrapper
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @public
	 * @example
	 *  const keys = CryptolizeCore.createAsymmetricKeys()
	 *  const record = CryptolizeCore.encryptRecord(..., keys.public, ...)
	 *  const headerWrapper = CryptolizeCore.decryptRecord(record, keys.private)
	 *  console.log(headerWrapper)
	 */
	function decrypt(record, headerKey) {
	  return (0, _aes.decryptObject)(record.headerWrapper, (0, _ecc.createSymmetricEncryptionKeyFromPrivateKey)(headerKey, record.headerWrapperEncryptionParams.tag), record.headerWrapperEncryptionParams.encryptionParams);
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _identity = __webpack_require__(76);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 */
	module.exports = _curry1(_identity);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(81);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(28);
	var _slice = __webpack_require__(3);
	
	
	/**
	 * Similar to hasMethod, this checks whether a function has a [methodname]
	 * function. If it isn't an array it will execute that function otherwise it
	 * will default to the ramda implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, _slice(arguments, 0, length - 1));
	  };
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(37);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _isString = __webpack_require__(40);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth('abc', 2); //=> 'c'
	 *      R.nth('abc', 3); //=> ''
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(6);
	var _reduce = __webpack_require__(30);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex
	 * @example
	 *
	 *      var numbers = [1, 2, 3];
	 *      var add = (a, b) => a + b;
	 *
	 *      R.reduce(add, 10, numbers); //=> 16
	 */
	module.exports = _curry3(_reduce);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(38);
	var slice = __webpack_require__(111);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _checkForMethod('tail', slice(1, Infinity));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _slice = __webpack_require__(3);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, R.unapply derives a variadic function from a function which
	 * takes an array. R.unapply is the inverse of R.apply.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(_slice(arguments));
	  };
	});


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return Promise.resolve((0, _webworkifyWebpack2.default)(/*require.resolve*/(48)));
	};
	
	var _webworkifyWebpack = __webpack_require__(115);
	
	var _webworkifyWebpack2 = _interopRequireDefault(_webworkifyWebpack);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.deriveKey = deriveKey;
	exports.createRandom = createRandom;
	exports.createKey = createKey;
	exports.createIV = createIV;
	exports.createAsymmetricKeys = createAsymmetricKeys;
	exports.createAsymmetricKeysECDSA = createAsymmetricKeysECDSA;
	exports.signWithECDSAPrivateKey = signWithECDSAPrivateKey;
	exports.verifyWithECDSAPublicKey = verifyWithECDSAPublicKey;
	exports.encryptText = encryptText;
	exports.decryptText = decryptText;
	exports.encryptObject = encryptObject;
	exports.decryptObject = decryptObject;
	exports.encryptKey = encryptKey;
	exports.decryptKey = decryptKey;
	exports.encryptRecord = encryptRecord;
	exports.decryptRecord = decryptRecord;
	exports.decryptKeyWithSymmetricEncryption = decryptKeyWithSymmetricEncryption;
	exports.decryptKeyWithAsymmetricEncryption = decryptKeyWithAsymmetricEncryption;
	exports.decryptData = decryptData;
	exports.decryptFile = decryptFile;
	
	var _detectWebworker = __webpack_require__(53);
	
	var _detectWebworker2 = _interopRequireDefault(_detectWebworker);
	
	var _detectNode = __webpack_require__(52);
	
	var _detectNode2 = _interopRequireDefault(_detectNode);
	
	var _createWorker = __webpack_require__(46);
	
	var _createWorker2 = _interopRequireDefault(_createWorker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var worker = null;
	var id = 0;
	
	/**
	 * Add entropy in order to seed the RNG
	 *
	 * @return {Promise}
	 * @private
	 */
	function addEntropy() {
	  var crypto = window.crypto || window.msCrypto;
	  if (!crypto) return Promise.reject(new Error('No crypto in browser'));
	  var ab = new Uint32Array(1024 / 32);
	  crypto.getRandomValues(ab);
	  return run(worker, 'addEntropy', [ab.buffer, 1024, 'crypto.getRandomValues'], [ab.buffer]);
	}
	
	function runWrapper(operation, args, transferables) {
	  if (_detectWebworker2.default || _detectNode2.default) return Promise.reject(new Error('can be called in browser environment only'));
	  return Promise.resolve().then(function () {
	    return !worker && init();
	  }).then(function () {
	    return run(worker, operation, args, transferables);
	  });
	}
	
	/**
	 * Run operation in web worker
	 *
	 * @param {WebWorker} worker
	 * @param {String} operation name of the operation
	 * @param {Array} args arguments which will be applied to the operation
	 * @param {Array} [transferables] transferables objects which will be copied efficiently through transferring ownership
	 * @return {Promise} the returned value from the operation
	 * @private
	 */
	function run(worker, operation, args, transferables) {
	  return new Promise(function (resolve, reject) {
	    var currentId = ++id;
	    function message(_ref) {
	      var _ref$data = _ref.data,
	          _id = _ref$data.id,
	          result = _ref$data.result,
	          err = _ref$data.err;
	
	      if (_id !== currentId) return;
	      worker.removeEventListener('message', message);
	      if (err) return reject(err);
	      resolve(result);
	    }
	    worker.addEventListener('message', message);
	    if (transferables && transferables.length) worker.postMessage({ id: currentId, operation: operation, args: args }, transferables);else worker.postMessage({ id: currentId, operation: operation, args: args }); // firefox throws error when empty array passed
	  });
	}
	
	function init() {
	  return (0, _createWorker2.default)().then(function (_worker) {
	    worker = _worker;
	    return addEntropy();
	  });
	}
	
	function deriveKey(password, params) {
	  return runWrapper('deriveKey', [password, params]);
	}
	
	function createRandom(bits) {
	  return runWrapper('createRandom', [bits]);
	}
	
	function createKey() {
	  return runWrapper('createKey');
	}
	
	function createIV() {
	  return runWrapper('createIV');
	}
	
	function createAsymmetricKeys(privateKey) {
	  return runWrapper('createAsymmetricKeys', [privateKey]);
	}
	
	function createAsymmetricKeysECDSA(privateKey) {
	  return runWrapper('createAsymmetricKeysECDSA', [privateKey]);
	}
	
	function signWithECDSAPrivateKey(privateKey, text) {
	  return runWrapper('signWithECDSAPrivateKey', [privateKey, text]);
	}
	
	function verifyWithECDSAPublicKey(publicKey, text, signature) {
	  return runWrapper('verifyWithECDSAPublicKey', [publicKey, text, signature]);
	}
	
	function encryptText(data, key, encryptionParams) {
	  return runWrapper('encryptText', [data, key, encryptionParams]);
	}
	
	function decryptText(data, key, encryptionParams) {
	  return runWrapper('decryptText', [data, key, encryptionParams]);
	}
	
	function encryptObject(data, key, encryptionParams) {
	  return runWrapper('encryptObject', [data, key, encryptionParams]);
	}
	
	function decryptObject(data, key, encryptionParams) {
	  return runWrapper('decryptObject', [data, key, encryptionParams]);
	}
	
	function encryptKey(data, key, encryptionParams) {
	  return runWrapper('encryptKey', [data, key, encryptionParams]);
	}
	
	function decryptKey(data, key, encryptionParams) {
	  return runWrapper('decryptKey', [data, key, encryptionParams]);
	}
	
	function encryptRecord(headerKey, metadata, blocks) {
	  return runWrapper('encryptRecord', [headerKey, metadata, blocks], blocks && blocks.map(function (block) {
	    return block.files;
	  }).reduce(function (a, b) {
	    return a.concat(b);
	  }, []).map(function (file) {
	    return file.data;
	  }));
	}
	
	function decryptRecord(record, headerKey) {
	  return runWrapper('decryptRecord', [record, headerKey], record && record.blocks && record.blocks.map(function (block) {
	    return block.files;
	  }).reduce(function (a, b) {
	    return a.concat(b);
	  }, []).map(function (file) {
	    return file.data;
	  }).filter(function (data) {
	    return data;
	  }));
	}
	
	function decryptKeyWithSymmetricEncryption(password, header) {
	  return runWrapper('decryptKeyWithSymmetricEncryption', [password, header]);
	}
	
	function decryptKeyWithAsymmetricEncryption(id, version, privateKey, header) {
	  return runWrapper('decryptKeyWithAsymmetricEncryption', [id, version, privateKey, header]);
	}
	
	function decryptData(data, key, encryptionParams) {
	  return runWrapper('decryptData', [data, key, encryptionParams]);
	}
	
	function decryptFile(file, key, encryptionParams) {
	  return runWrapper('decryptFile', [file, key, encryptionParams], file && [file]);
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	/**
	 * Async handler which runs in web worker
	 * @private
	 */
	function run() {
	  __webpack_require__(49);
	}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _sjcl = __webpack_require__(11);
	
	var _sjcl2 = _interopRequireDefault(_sjcl);
	
	var _keyDerivation = __webpack_require__(23);
	
	var _random = __webpack_require__(15);
	
	var _ecc = __webpack_require__(10);
	
	var _aes = __webpack_require__(7);
	
	var _record = __webpack_require__(35);
	
	var _header = __webpack_require__(26);
	
	var _data = __webpack_require__(24);
	
	var _file = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var operations = {
	  addEntropy: function (ab, entropy, source) {
	    return _sjcl2.default.random.addEntropy(new Uint32Array(ab), entropy, source);
	  },
	  deriveKey: _keyDerivation.deriveKey,
	  createRandom: _random.createRandom,
	  createKey: _random.createKey,
	  createIV: _random.createIV,
	  createAsymmetricKeys: _ecc.createAsymmetricKeys,
	  createAsymmetricKeysECDSA: _ecc.createAsymmetricKeysECDSA,
	  signWithECDSAPrivateKey: _ecc.signWithECDSAPrivateKey,
	  verifyWithECDSAPublicKey: _ecc.verifyWithECDSAPublicKey,
	  encryptText: _aes.encryptText,
	  decryptText: _aes.decryptText,
	  encryptObject: _aes.encryptObject,
	  decryptObject: _aes.decryptObject,
	  encryptKey: _aes.encryptKey,
	  decryptKey: _aes.decryptKey,
	  encryptRecord: _record.encrypt,
	  decryptRecord: _record.decrypt,
	  decryptKeyWithSymmetricEncryption: _header.decryptKeyWithSymmetricEncryption,
	  decryptKeyWithAsymmetricEncryption: _header.decryptKeyWithAsymmetricEncryption,
	  decryptData: _data.decrypt,
	  decryptFile: _file.decrypt
	}; /* global self */
	
	var toTransferables = {
	  encryptRecord: function (record) {
	    return record.blocks.map(function (block) {
	      return block.files;
	    }).reduce(function (a, b) {
	      return a.concat(b);
	    }, []).map(function (file) {
	      return file.data;
	    });
	  },
	  decryptFile: function (file) {
	    return [file];
	  }
	};
	
	self.addEventListener('message', function (e) {
	  try {
	    var operation = operations[e.data.operation];
	    if (!operation) return self.postMessage({ id: e.data.id, result: '' });
	    var result = operation.apply(null, e.data.args);
	    if (toTransferables[e.data.operation]) self.postMessage({ id: e.data.id, result: result }, toTransferables[e.data.operation](result));else self.postMessage({ id: e.data.id, result: result }); // firefox throws error when empty array passed
	  } catch (err) {
	    self.postMessage({ id: e.data.id, err: err.toString() });
	  }
	});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eqProps = __webpack_require__(60);
	
	var _eqProps2 = _interopRequireDefault(_eqProps);
	
	var _dropRepeatsWith = __webpack_require__(59);
	
	var _dropRepeatsWith2 = _interopRequireDefault(_dropRepeatsWith);
	
	var _ = __webpack_require__(16);
	
	var _2 = _interopRequireDefault(_);
	
	var _curry = __webpack_require__(5);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	var _props = __webpack_require__(33);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _of = __webpack_require__(102);
	
	var _of2 = _interopRequireDefault(_of);
	
	var _concat = __webpack_require__(56);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _useWith = __webpack_require__(34);
	
	var _useWith2 = _interopRequireDefault(_useWith);
	
	var _apply = __webpack_require__(17);
	
	var _apply2 = _interopRequireDefault(_apply);
	
	var _pick = __webpack_require__(103);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _identity = __webpack_require__(36);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _prop = __webpack_require__(14);
	
	var _prop2 = _interopRequireDefault(_prop);
	
	var _mergeAll = __webpack_require__(99);
	
	var _mergeAll2 = _interopRequireDefault(_mergeAll);
	
	var _unapply = __webpack_require__(45);
	
	var _unapply2 = _interopRequireDefault(_unapply);
	
	var _converge = __webpack_require__(18);
	
	var _converge2 = _interopRequireDefault(_converge);
	
	var _map = __webpack_require__(13);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _objOf = __webpack_require__(32);
	
	var _objOf2 = _interopRequireDefault(_objOf);
	
	var _compose = __webpack_require__(8);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	exports._createEncryptionParamsObj = _createEncryptionParamsObj;
	exports._createSymmetricEncryptionParams = _createSymmetricEncryptionParams;
	exports._createAsymmetricEncryptionParams = _createAsymmetricEncryptionParams;
	exports._createFileParams = _createFileParams;
	exports.encrypt = encrypt;
	
	var _random = __webpack_require__(15);
	
	var _ecc = __webpack_require__(10);
	
	var _header = __webpack_require__(26);
	
	var _data = __webpack_require__(24);
	
	var _format = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create Object containing encryptionParams
	 *
	 * @return {{encryptionParams: SymmetricEncryptionParams}}
	 * @private
	 */
	function _createEncryptionParamsObj() {
	  return (0, _compose2.default)((0, _objOf2.default)('encryptionParams'), _format.createEncryptionParams, _random.createIV)();
	}
	
	/**
	 * Prepare params for symmetric encryption
	 *
	 * @param {{password: String, hint: String, iterations: Number}[]} passwords passwords for symmetric encryption
	 * @return {{derivationParams: DerivationParams, encryptionParams: SymmetricEncryptionParams, password: String, hint: String}[]}
	 * @private
	 */
	function _createSymmetricEncryptionParams(passwords) {
	  return (0, _map2.default)((0, _converge2.default)((0, _unapply2.default)(_mergeAll2.default), [(0, _compose2.default)((0, _objOf2.default)('derivationParams'), (0, _converge2.default)(_format.createDerivationParams, [(0, _prop2.default)('iterations'), _random.createSalt])), _createEncryptionParamsObj, _identity2.default]))(passwords);
	}
	
	/**
	 * Prepare params for symmetric encryption
	 *
	 * @param {{id: String, version: String, key: ElGamalPublicKey}[]} publicKeys public keys for asymmetric encryption
	 * @return {{tag: Base64UrlString, key: Base64UrlString, encryptionParams: SymmetricEncryptionParams, id: String, version: String}[]}
	 * @private
	 */
	function _createAsymmetricEncryptionParams(publicKeys) {
	  return (0, _map2.default)((0, _converge2.default)((0, _unapply2.default)(_mergeAll2.default), [(0, _compose2.default)(_ecc.createSymmetricEncryptionKeyFromPublicKey, (0, _prop2.default)('key')), _createEncryptionParamsObj, (0, _pick2.default)(['id', 'version'])]))(publicKeys);
	}
	
	/**
	 * Prepare params for files
	 *
	 * @param {{name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer}[]} files
	 * @return {{name: String, size: Number, type: String, id: String, data: ArrayBuffer, encryptionParams: SymmetricEncryptionParams}[]}
	 * @private
	 */
	function _createFileParams(files) {
	  return (0, _map2.default)((0, _converge2.default)((0, _unapply2.default)(_mergeAll2.default), [_identity2.default, _createEncryptionParamsObj]))(files);
	}
	
	/**
	 * Encrypt block
	 *
	 * @param {{password: String, hint: String}[]} passwords passwords for symmetric encryption
	 * @param {{id: String, version: String, key: ElGamalPublicKey}[]} publicKeys public keys for asymmetric encryption
	 * @param {String} text
	 * @param {{name: String, size: Number, type: String, id: String, path: String, service: String, data: ArrayBuffer}[]} files
	 * @return {Block} Block object consists of encrypted parts
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encrypt(passwords, publicKeys, text, files) {
	  return (0, _converge2.default)((0, _compose2.default)((0, _apply2.default)(_format.createBlock), (0, _useWith2.default)(_concat2.default, [_of2.default, (0, _props2.default)(['data', 'files'])])), [(0, _curry2.default)(_header.encryptKey)(_2.default, _2.default, _2.default, _createSymmetricEncryptionParams(passwords), _createAsymmetricEncryptionParams((0, _dropRepeatsWith2.default)((0, _eqProps2.default)('key'), publicKeys))), (0, _curry2.default)(_data.encrypt)(_2.default, _2.default, text, _2.default)])((0, _random.createKey)(), (0, _format.createEncryptionParams)((0, _random.createIV)()), _createFileParams(files));
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.encryptWithSymmetricEncryption = encryptWithSymmetricEncryption;
	exports.decryptWithSymmetricEncryption = decryptWithSymmetricEncryption;
	exports.encryptWithAsymmetricEncryption = encryptWithAsymmetricEncryption;
	exports.decryptWithAsymmetricEncryption = decryptWithAsymmetricEncryption;
	
	var _aes = __webpack_require__(7);
	
	var _ecc = __webpack_require__(10);
	
	var _keyDerivation = __webpack_require__(23);
	
	var _format = __webpack_require__(4);
	
	/**
	 * Encrypt key symmetrically
	 *
	 * @param {Base64UrlString} key
	 * @param {DerivationParams} derivationParams
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @param {String} password
	 * @param {String} hint
	 * @return {SymmetricEncryptionWrapper}
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encryptWithSymmetricEncryption(key, derivationParams, encryptionParams, password, hint) {
	  return (0, _format.createSymmetricEncryptionWrapper)(hint, derivationParams, encryptionParams, (0, _aes.encryptKey)(key, (0, _keyDerivation.deriveKey)(password, derivationParams), encryptionParams));
	}
	
	/**
	 * Decrypt key symmetrically
	 *
	 * @param {String} password
	 * @param {SymmetricEncryptionWrapper} symmetricEncryptionWrapper
	 * @return {Base64UrlString}
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @private
	 */
	function decryptWithSymmetricEncryption(password, symmetricEncryptionWrapper) {
	  return (0, _aes.decryptKey)(symmetricEncryptionWrapper.encryptedKey, (0, _keyDerivation.deriveKey)(password, symmetricEncryptionWrapper.derivationParams), symmetricEncryptionWrapper.encryptionParams);
	}
	
	/**
	 * Encrypt key asymmetrically
	 *
	 * @param {Base64UrlString} key
	 * @param {Base64UrlString} tag
	 * @param {SymmetricEncryptionParams} encryptionParams
	 * @param {Base64UrlString} encryptionKey
	 * @param {String} id
	 * @param {String} version
	 * @return {AsymmetricEncryptionWrapper}
	 * @throws {Error} if a parameter is invalid
	 * @private
	 */
	function encryptWithAsymmetricEncryption(key, tag, encryptionParams, encryptionKey, id, version) {
	  return (0, _format.createAsymmetricEncryptionWrapper)(id, version, tag, encryptionParams, (0, _aes.encryptKey)(key, encryptionKey, encryptionParams));
	}
	
	/**
	 * Decrypt key asymmetrically
	 *
	 * @param {ElGamalPrivateKey} privateKey
	 * @param {AsymmetricEncryptionWrapper} asymmetricEncryptionWrapper
	 * @return {Base64UrlString}
	 * @throws {Error} if a parameter is invalid, data is corrupt or wrong key
	 * @private
	 */
	function decryptWithAsymmetricEncryption(privateKey, asymmetricEncryptionWrapper) {
	  return (0, _aes.decryptKey)(asymmetricEncryptionWrapper.encryptedKey, (0, _ecc.createSymmetricEncryptionKeyFromPrivateKey)(privateKey, asymmetricEncryptionWrapper.tag), asymmetricEncryptionWrapper.encryptionParams);
	}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = false;
	
	// Only Node.JS has a process variable that is of [[Class]] process
	try {
	 module.exports = Object.prototype.toString.call(global.process) === '[object process]' 
	} catch(e) {}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = false;
	try {
	  module.exports = self instanceof WorkerGlobalScope
	} catch(e) {}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> * -> *
	 * @param {Boolean} a A boolean value
	 * @param {Boolean} b A boolean value
	 * @return {Boolean} `true` if both arguments are `true`, `false` otherwise
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(12);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var flip = __webpack_require__(64);
	var invoker = __webpack_require__(93);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} a
	 * @param {Array|String} b
	 * @return {Array|String}
	 *
	 * @example
	 *
	 *      R.concat([], []); //=> []
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 */
	module.exports = flip(invoker(1, 'concat'));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var curry = __webpack_require__(5);
	var nAry = __webpack_require__(100);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic constructor function
	 *      var Widget = () => {
	 *        this.children = Array.prototype.slice.call(arguments);
	 *        // ...
	 *      };
	 *      Widget.prototype = {
	 *        // ...
	 *      };
	 *      var allConfigs = [
	 *        // ...
	 *      ];
	 *      R.map(R.constructN(1, Widget), allConfigs); // a list of Widgets
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop the name of the property to dissociate
	 * @param {Object} obj the object to clone
	 * @return {Object} a new object similar to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    if (p !== prop) {
	      result[p] = obj[p];
	    }
	  }
	  return result;
	});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(19);
	var _xdropRepeatsWith = __webpack_require__(88);
	var last = __webpack_require__(97);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate two consecutive elements. The
	 * first element in a series of equal element is the one being preserved.
	 *
	 * Dispatches to the `dropRepeatsWith` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable('dropRepeatsWith', _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(6);
	var equals = __webpack_require__(27);
	
	
	/**
	 * Reports whether two objects have the same value, in `R.equals` terms, for
	 * the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function' ? transformation(object[key])
	                : type === 'object'   ? evolve(transformations[key], object[key])
	                                      : object[key];
	  }
	  return result;
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(19);
	var _filter = __webpack_require__(74);
	var _isObject = __webpack_require__(79);
	var _reduce = __webpack_require__(30);
	var _xfilter = __webpack_require__(89);
	var keys = __webpack_require__(22);
	
	
	/**
	 * Takes a predicate and a "filterable", and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable('filter', _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _dispatchable = __webpack_require__(19);
	var _xfind = __webpack_require__(90);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable('find', _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _slice = __webpack_require__(3);
	var curry = __webpack_require__(5);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = _slice(arguments);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(42);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(6);
	var curryN = __webpack_require__(9);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(6);
	var _slice = __webpack_require__(3);
	
	
	/**
	 * Inserts the supplied element into the list, at index `index`. _Note that
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = _slice(list);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(77);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(12);
	var _isPlaceholder = __webpack_require__(21);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(69);
	var _functionName = __webpack_require__(75);
	var _has = __webpack_require__(20);
	var identical = __webpack_require__(66);
	var keys = __webpack_require__(22);
	var type = __webpack_require__(114);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(27);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(20);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(20);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(71);
	var _map = __webpack_require__(29);
	var _quote = __webpack_require__(84);
	var _toISOString = __webpack_require__(86);
	var keys = __webpack_require__(22);
	var reject = __webpack_require__(109);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	  XDropRepeatsWith.prototype['@@transducer/init'] = function() {
	    return this.xf['@@transducer/init']();
	  };
	  XDropRepeatsWith.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(31);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _reduced = __webpack_require__(85);
	var _xfBase = __webpack_require__(31);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _xfBase = __webpack_require__(31);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var _slice = __webpack_require__(3);
	var curryN = __webpack_require__(9);
	var is = __webpack_require__(94);
	var toString = __webpack_require__(112);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && is(Function, target[method])) {
	      return target[method].apply(target, _slice(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isArray = __webpack_require__(28);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (x instanceof String) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(42);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(37);
	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); => true
	 *      R.not(1); => false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _of = __webpack_require__(82);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(12);
	var _pipe = __webpack_require__(83);
	var reduce = __webpack_require__(43);
	var tail = __webpack_require__(44);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1);
	var map = __webpack_require__(13);
	var prop = __webpack_require__(14);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig k -> [{k: v}] -> [v]
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(39);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(6);
	var equals = __webpack_require__(27);
	var propSatisfies = __webpack_require__(108);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in `R.equals`
	 * terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return propSatisfies(equals(val), name, obj);
	});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(70);
	var _curry2 = __webpack_require__(1);
	var filter = __webpack_require__(62);
	
	
	/**
	 * The complement of `filter`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _isString = __webpack_require__(40);
	var _slice = __webpack_require__(3);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           _slice(list).reverse();
	});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(38);
	var _curry3 = __webpack_require__(6);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	var _toString = __webpack_require__(87);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(12);
	var _concat = __webpack_require__(39);
	var _curry2 = __webpack_require__(1);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F, {x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F, null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(2);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	function webpackBootstrapFunc (modules) {
	/******/  // The module cache
	/******/  var installedModules = {};
	
	/******/  // The require function
	/******/  function __webpack_require__(moduleId) {
	
	/******/    // Check if module is in cache
	/******/    if(installedModules[moduleId])
	/******/      return installedModules[moduleId].exports;
	
	/******/    // Create a new module (and put it into the cache)
	/******/    var module = installedModules[moduleId] = {
	/******/      i: moduleId,
	/******/      l: false,
	/******/      exports: {}
	/******/    };
	
	/******/    // Execute the module function
	/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/    // Flag the module as loaded
	/******/    module.l = true;
	
	/******/    // Return the exports of the module
	/******/    return module.exports;
	/******/  }
	
	/******/  // expose the modules object (__webpack_modules__)
	/******/  __webpack_require__.m = modules;
	
	/******/  // expose the module cache
	/******/  __webpack_require__.c = installedModules;
	
	/******/  // identity function for calling harmony imports with the correct context
	/******/  __webpack_require__.i = function(value) { return value; };
	
	/******/  // define getter function for harmony exports
	/******/  __webpack_require__.d = function(exports, name, getter) {
	/******/    if(!__webpack_require__.o(exports, name)) {
	/******/      Object.defineProperty(exports, name, {
	/******/        configurable: false,
	/******/        enumerable: true,
	/******/        get: getter
	/******/      });
	/******/    }
	/******/  };
	
	/******/  // getDefaultExport function for compatibility with non-harmony modules
	/******/  __webpack_require__.n = function(module) {
	/******/    var getter = module && module.__esModule ?
	/******/      function getDefault() { return module['default']; } :
	/******/      function getModuleExports() { return module; };
	/******/    __webpack_require__.d(getter, 'a', getter);
	/******/    return getter;
	/******/  };
	
	/******/  // Object.prototype.hasOwnProperty.call
	/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/  // __webpack_public_path__
	/******/  __webpack_require__.p = "/";
	
	/******/  // on error function for async loading
	/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };
	
	  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)
	  return f.default || f // try to call default if defined to also support babel esmodule exports
	}
	
	var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+'
	var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
	
	// http://stackoverflow.com/a/2593661/130442
	function quoteRegExp (str) {
	  return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
	}
	
	function getModuleDependencies (sources, module, queueName) {
	  var retval = {}
	  retval[queueName] = []
	
	  var fnString = module.toString()
	  var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/)
	  if (!wrapperSignature) return retval
	  var webpackRequireName = wrapperSignature[1]
	
	  // main bundle deps
	  var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g')
	  var match
	  while ((match = re.exec(fnString))) {
	    if (match[3] === 'dll-reference') continue
	    retval[queueName].push(match[3])
	  }
	
	  // dll deps
	  re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g')
	  while ((match = re.exec(fnString))) {
	    if (!sources[match[2]]) {
	      retval[queueName].push(match[1])
	      sources[match[2]] = __webpack_require__(match[1]).m
	    }
	    retval[match[2]] = retval[match[2]] || []
	    retval[match[2]].push(match[4])
	  }
	
	  return retval
	}
	
	function hasValuesInQueues (queues) {
	  var keys = Object.keys(queues)
	  return keys.reduce(function (hasValues, key) {
	    return hasValues || queues[key].length > 0
	  }, false)
	}
	
	function getRequiredModules (sources, moduleId) {
	  var modulesQueue = {
	    main: [moduleId]
	  }
	  var requiredModules = {
	    main: []
	  }
	  var seenModules = {
	    main: {}
	  }
	
	  while (hasValuesInQueues(modulesQueue)) {
	    var queues = Object.keys(modulesQueue)
	    for (var i = 0; i < queues.length; i++) {
	      var queueName = queues[i]
	      var queue = modulesQueue[queueName]
	      var moduleToCheck = queue.pop()
	      seenModules[queueName] = seenModules[queueName] || {}
	      if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
	      seenModules[queueName][moduleToCheck] = true
	      requiredModules[queueName] = requiredModules[queueName] || []
	      requiredModules[queueName].push(moduleToCheck)
	      var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName)
	      var newModulesKeys = Object.keys(newModules)
	      for (var j = 0; j < newModulesKeys.length; j++) {
	        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || []
	        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]])
	      }
	    }
	  }
	
	  return requiredModules
	}
	
	module.exports = function (moduleId, options) {
	  options = options || {}
	  var sources = {
	    main: __webpack_require__.m
	  }
	
	  var requiredModules = options.all ? { main: Object.keys(sources) } : getRequiredModules(sources, moduleId)
	
	  var src = ''
	
	  Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
	    var entryModule = 0
	    while (requiredModules[module][entryModule]) {
	      entryModule++
	    }
	    requiredModules[module].push(entryModule)
	    sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'
	    src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n'
	  })
	
	  src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '})(self);'
	
	  var blob = new window.Blob([src], { type: 'text/javascript' })
	  if (options.bare) { return blob }
	
	  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL
	
	  var workerUrl = URL.createObjectURL(blob)
	  var worker = new window.Worker(workerUrl)
	  worker.objectURL = workerUrl
	
	  return worker
	}


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// cryptolize-core.min.js